/*

* データ構造

業務チェックシート prc
　チェックシート  cm40l11e: 'prcSht', cm40l11k: '1'
　確認項目
　　確認事項 it10l11e: 'prcChk', it10l11k: sg_pageKey
　　失敗・クレーム事例 it10l11e: 'prcCase', it10l11k: sg_pageKey
　　添付ファイル

マネジメント見える化チェックシート mng
　チェックシート cm40l11e: 'mngSht', cm40h11k: '1', cm40h11c: '2'
　　チェック項目分類 cm40l11e: 'mngCtg', cm40l11k: sgc_pageKey, cm40h11c: '3'
　　　チェック項目 it10l11e: 'mngChk', it10l11k: _pntKey,
　　失敗・クレーム事例 it10l11e: 'mngCXase', it10l11k: _pntKey,

データの構造が異なるため、出力・取込機能は種類ごとに分ける、全てを一塊にしない

表示順はシートにおいて登録可能とするが、

*/

import {Dimensions} from 'react-native';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { cf } from './cf';
import { ce } from './ce';
import { cp } from './cp';

//export class ip { // individual call
export class ip { // individual call

  static $ip_hlr_cm1i = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    cnd: '',
    ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {

    let _cnd = ''

    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
    else {
      if (bf.f(pd.cm10_key)) {
        _cnd = bf.q(`[cm1ib11k]="{}"`.f(
          pd.cm10_key,
        ));
      };
    };

    cf.myCB_hlr({
      elm: 'cm1i',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      cnd: _cnd,
      ld_sortss: pd.ld_sortss,
      b_withCnd: false,
      do_rfrs: {
      },
      dld_pcksss: {
      },
      od_setDefs: _d_is => {
        if (bf.f(_d_is)) {
          let _d = {
            s_cm1ii110: _d_is.cm1ii110 || '',
            s_cm1ii210: _d_is.cm1ii210 || '',
            s_cm1ii310: _d_is.cm1ii310 || '',
          };
          return _d;
        }
        else {
          let _d = {
            s_cm1ii110: '',
            s_cm1ii210: '',
            s_cm1ii310: '',
          };
          return _d;
        };
      },
      od_insDefs: () => {
        return {
        };
      },
      od_updDefs: () => {
        return {
        };
      },
      od_upsDefs: () => {
        let _d = {
          cm1ib11k: global.c?.state.sgcd_pagePntKeys.cm10_key || '',
          cm1ii110: global.c?.state.s_cm1ii110 || '',
          cm1ii210: global.c?.state.s_cm1ii210 || '',
          cm1ii310: global.c?.state.s_cm1ii310 || '',
        };
        return _d;
      },
      od_itemsDefs: _d_is => {
        return {
        }
      },
      od_fileDefs: _d_is => {
        return {
        }
      },
    })
    .then( _a_r =>{ // 'ins' の場合に必要
      _o_end1(_a_r);
    });
  });

  static $ip_hlr_it10 = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    d_vals: {},
    cnd: '',
    ld_sortss: [{fld:'it20c310', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {

    let _cnd = ''
    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
    else {
    };

    cf.myCB_hlr({
      elm: 'it10',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      cnd: _cnd,
      ld_sortss: pd.ld_sortss,
      b_withCnd: false,
      do_rfrs: {
      },
      dld_pcksss: {
      },
      od_setDefs: _d_is => {
        if (bf.f(_d_is)) { // 存在する場合
          return {
          };
        }
        else {
          return { // 存在しない場合
          };
        };
      },
      od_insDefs: () => {
        return {
        };
      },
      od_updDefs: () => {
        return {
        };
      },
      od_upsDefs: () => {
        return pd.d_vals;
      },
      od_itemsDefs: _d_is => {
        return {
        }
      },
      od_fileDefs: _d_is => {
        return {
        }
      },
    })
    .then( _a_r =>{ // 'ins' の場合に必要
      _o_end1(_a_r);
    });

  });

  static $ip_hlr_it20 = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    d_vals: {},
    cnd: '',
    ld_sortss: [{fld:'it20c310', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {

    let _cnd = ''
    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
/*
    else if (
      bf.f(pd.cm10_key) && 
      bf.f(pd.cm40_key) &&
      !bf.f(pd.it20c310)
    ) {
      _cnd = bf.q(`[it20b11k]="{}" AND [it20b21k]="{}"`.f(
        pd.cm10_key,
        pd.cm40_key,
      ));
    }
    else if (
      bf.f(pd.cm10_key) && 
      bf.f(pd.cm40_key) && 
      bf.f(pd.it20c310)
    ) {
      _cnd = bf.q(`[it20b11k]="{}" AND [it20b21k]="{}" AND [it20c310]="{}"`.f(
        pd.cm10_key,
        pd.cm40_key,
        pd.it20c310,
      ));
    };
*/

    cf.myCB_hlr({
      elm: 'it20',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      cnd: _cnd,
      ld_sortss: pd.ld_sortss,
      b_withCnd: false,
      do_rfrs: {
      },
      dld_pcksss: {
      },
      od_setDefs: _d_is => {
        if (bf.f(_d_is)) { // 存在する場合
          return {
            s_it20_key: _d_is._KEY || -1,
            s_it20c310: _d_is.it20c310 || '',
          };
        }
        else {
          return { // 存在しない場合
            s_it20_key: -1,
            s_it20c310: bf.myDT_get_now().substr(0,10),
          };
        };
      },
      od_insDefs: () => {
        return {
        };
      },
      od_updDefs: () => {
        return {
        };
      },
      od_upsDefs: () => {
        return pd.d_vals;
      },
      od_itemsDefs: _d_is => {
        return {
          pfx: '{}'.f(_d_is.it20c310)
        }
      },
      od_fileDefs: _d_is => {
        return {
        }
      },
    })
    .then( _a_r =>{ // 'ins' の場合に必要
      _o_end1(_a_r);
    });

  });

  static $ip_hlr_it30 = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    d_vals: {},
    cnd: '',
    ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {

    let _cnd = ''
    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
/*
    else if(
      bf.f(pd.cm10_key) &&
      bf.f(pd.it10_key) &&
      bf.f(pd.it20_key)
    ) {
      _cnd = bf.q(`[it30b11k]="{}" AND [it30b21k]="{}" AND [it30b31k]="{}"`.f(
        pd.cm10_key,
        pd.it10_key,
        pd.it20_key,
      ));
    };
*/

    cf.myCB_hlr({
      elm: 'it30',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      cnd: _cnd,
      ld_sortss: pd.ld_sortss,
      b_withCnd: false,
      do_rfrs: {
      },
      dld_pcksss: {
      },
      od_setDefs: _d_is => {
        return {
        };
      },
      od_insDefs: () => {
        return {
        };
      },
      od_updDefs: () => {
        return {
        };
      },
      od_upsDefs: () => {
        return pd.d_vals;
      },
      od_itemsDefs: _d_is => {
        return {
        }
      },
      od_fileDefs: _d_is => {
        return {
        }
      },
    })
    .then( _a_r =>{ // 'ins' の場合に必要
      _o_end1(_a_r);
    });

  });


static $o_pmn = (pd={ // permission
  mode: '',
  d_is: {},
}) => { // state の場合、何度か render されるなかで値が初期化される場合があるようなので、function として実装
  let _r = null;
  switch (pd.mode) {
    case 'type':
      _r = bf.b([
        {
          b_when: 
            bf.i(global.c?.state.sgc_pageRole, ['own1']),
          o_then: () => 
            '90',
        },
        {
          b_when: 
            bf.i(global.c?.state.sgc_pageRole, ['own2', 'adm1']),
          o_then: () => 
            '30',
        },
        {
          b_when: 
            bf.i(global.c?.state.sgc_pageRole, ['own3', 'adm2', 'mmb1']) &&
            global.c?.state.sgcd_pagePntKeys.cm31c410 == '20'
          , // 部門担当者
          o_then: () => 
            '20',
        },
        {
          o_else: () => 
            '10',
        },
      ]);
      break;
    case 'eblPage': // editable page
      _r = bf.b([
        {
          b_when: 
            bf.i(global.c?.state.sgc_pageRole, ['own1']),
          o_then: () => 
            true,
        },
        {
          b_when: 
            bf.i(global.c?.state.sgc_pageRole, ['adm1', 'own2']) && 
//            global.c?.state.s_cm40t110 == '30',
            pd.t110 == '30',
          o_then: () => 
            true,
        },
        {
          b_when: 
            bf.i(global.c?.state.sgc_pageRole, ['mmb1', 'adm2', 'own3']) && 
            global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' // 設定ページ
//            global.c?.state.s_cm31c410 == '20' // 部門運営者
          ,
          o_then: () => 
            true,
        },
        {
          o_else: () => 
            false,
        },
      ]);
//bf.l('404: {}, {}, {}, {}'.f(_r, global.c?.state.sgc_pageRole, pd.t110, global.c?.state.s_cm31c410))
      break;
    case 'vsbLine': // visible line
      _r = bf.b([
        {
          b_when: 
            pd.t110 == '90', // 基本コンテンツ
          o_then: () => 
            true,
        },
        {
          b_when: 
            pd.t110 == '30', // 全社共通コンテンツ
          o_then: () => 
            true,
        },
        {
          b_when: 
            pd.t110 == '20' && // 部門共通コンテンツ
            global.c?.state.sgcd_pagePntKeys?.cm31c410 == '20' && // 設定タブ
            bf.i(global.c?.state.sgc_pageMode, ['new', 'edit','show']),
          o_then: () => 
            true,
        },
        {
          b_when: 
            pd.t110 == '20' && // 部門共通コンテンツ
            global.c?.state.sgcd_pagePntKeys?.cm31c410 == '10' && // 閲覧タブ
            bf.i(global.c?.state.sgc_pageMode, ['show']),
          o_then: () => 
            true,
        },
        {
          b_when: 
            pd.t110 == '10' && // 個人コンテンツ
            global.c?.state.sgcd_pagePntKeys?.cm31c410 == '20' && // 設定タブ
//            bf.i(global.c?.state.sgc_pageMode, ['show']),
            bf.i(global.c?.state.sgc_pageMode, ['new', 'edit', 'show']),
          o_then: () => 
            true,
        },
        {
          b_when: 
            pd.t110 == '10' && // 個人コンテンツ
            global.c?.state.sgcd_pagePntKeys?.cm31c410 == '10' && // 閲覧タブ
            bf.i(global.c?.state.sgc_pageMode, ['new','edit','show']) &&
            pd.b21k == global.c?.state.sgcd_pagePntKeys?.cm10_key,
          o_then: () => 
            true,
        },
        {
          o_else: () => 
            false,
        },
      ]);
//bf.l('465: {}, {}, {}, {}'.f( _r, pd.t110, global.c?.state.sgc_pageRole, global.c?.state.sgcd_pagePntKeys?.cm31c410));
      break;
    case 'eblLine': // editable line
      _r = bf.b([
        {
          b_when: 
//            pd.d_is.it10t110 == '90' && 
            pd.t110 == '90' && 
            bf.i(global.c?.state.sgc_pageRole, ['own1']),
          o_then: () => 
            true,
        },
        {
          b_when: 
//            pd.d_is.it10t110 == '30' && 
            pd.t110 == '30' && 
            bf.i(global.c?.state.sgc_pageRole, ['own2', 'adm1']),
          o_then: () => 
            true,
        },
        {
          b_when: 
//            pd.d_is.it10t110 == '20' && 
/*
            pd.t110 == '20' && 
            bf.i(global.c?.state.sgc_pageRole, ['own4', 'adm3', 'mmb2']),
*/
            pd.t110 == '20' && // 部門共通
            bf.i(global.c?.state.sgc_pageRole, ['mmb1', 'adm2', 'own3']) &&
            global.c?.state.sgcd_pagePntKeys?.cm31cz10 == '20', // 設定タブ
          o_then: () => 
            true,
        },
        {
          b_when: 
//            pd.d_is.it10t110 == '10' && 
            pd.t110 == '10' && 
            bf.i(global.c?.state.sgc_pageRole, ['own3', 'adm2', 'mmb1']) && 
//            pd.d_is.it10cy20 == global.c?.state.sgcd_pagePntKeys.cm10_key,
            pd.cy20 == global.c?.state.sgcd_pagePntKeys.cm10_key,
          o_then: () => 
            true,
        },
        {
          o_else: () => 
            false,
        },
      ]);
      break;
/*
    case 'eblFile': // editable file
      _r = bf.b([ // ここで持たせるべきか、個別で持たせるべきか
        {
          b_when: 
            pd.d_is.ct10t110 == '90' && 
            bf.i(global.c?.state.sgc_pageRole, ['own1']),
          o_then: () => 
            true,
        },
        {
          b_when: 
            pd.d_is.ct10t110 == '30' && 
            bf.i(global.c?.state.sgc_pageRole, ['own2', 'adm1']),
          o_then: () => 
            true,
        },
        {
          b_when: 
            pd.d_is.ct10t110 == '20' && 
            bf.i(global.c?.state.sgc_pageRole, ['own4', 'adm3', 'mmb2']),
          o_then: () => 
            true,
        },
        {
          b_when: 
            pd.d_is.ct10t110 == '10' && 
            pd.d_is.ct10cy20 == global.c?.state.sgcd_pagePntKeys.cm10_key &&
            bf.i(global.c?.state.sgc_pageRole, ['own3', 'adm2', 'mmb1']), 
          o_then: () => 
            true,
        },
        {
          o_else: () => 
            false,
        },
      ]);
      break;
*/
    case 'ccd': // color code
/*
      _r = bf.b([
        {
          b_when: pd.d_is.it10t110 == '90',
          o_then: () => '#c40000',
        },
        {
          b_when: pd.d_is.it10t110 == '30',
          o_then: () => '#006400',
        },
        {
          b_when: pd.d_is.it10t110 == '20',
          o_then: () => '#707070',
        },
        {
          o_else: () => '#007bbb',
        },
      ]);
*/
      _r = bf.b([
        {
          b_when: pd.t110 == '90',
          o_then: () => '#c40000',
        },
        {
          b_when: pd.t110 == '30',
          o_then: () => '#006400',
        },
        {
          b_when: pd.t110 == '20',
//          o_then: () => '#707070',
//          o_then: () => '#007bbb',
          o_then: () => 'orange',
        },
        {
//          o_else: () => '#007bbb',
          o_else: () => '#707070',
        },
      ]);
      break;
    case 'cndIt10':
      _r = bf.b([
        {
          b_when: bf.i(global.c?.state.sgc_pageRole, ['own1']),
          o_then: () => bf.q(`
            [it10l11e]="{}" AND 
            [it10l11k]="{}" AND 
            (
              [it10t110] IN ("90") 
            ) AND
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            pd.tgt,
            pd.cm40_key || global.c?.state.sgc_pageKey
          )),
        },
        {
          b_when: bf.i(global.c?.state.sgc_pageRole, ['adm1', 'own2']),
          o_then: () => bf.q(`
            [it10l11e]="{}" AND 
            [it10l11k]="{}" AND 
            (
              [it10t110]="90" OR 
              (
                [it10t110]="30" AND 
                [it10b11k]="{}"
              )
            ) AND 
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            pd.tgt,
            pd.cm40_key || global.c?.state.sgc_pageKey,
            pd.cm20_key || global.c?.state.sgcd_pagePntKeys.cm20_key,
          )),
        },
        {
          b_when: 
            bf.i(global.c?.state.sgc_pageRole, ['mmb1', 'adm2', 'own3']) &&
            global.c?.state.sgcd_pagePntKeys?.cm31cz10 == '20' // 設定タブ
          ,
          o_then: () => bf.q(`
            [it10l11e]="{}" AND 
            [it10l11k]="{}" AND 
            (
              [it10t110]="90" OR 
              (
                [it10t110]="30" AND 
                [it10b11k]="{}"
              ) OR 
              (
                [it10t110]="20" AND 
                [it10b31k]="{}"
              ) OR 
              (
                [it10t110]="10"
              )
            ) AND 
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            pd.tgt,
            pd.cm40_key || global.c?.state.sgc_pageKey,
            pd.cm20_key || global.c?.state.sgcd_pagePntKeys.cm20_key,
            pd.cm30_key || global.c?.state.sgcd_pagePntKeys.cm30_key,
          )),
        },
        {
          b_when: 
            bf.i(global.c?.state.sgc_pageRole, ['mmb1', 'adm2', 'own3']) &&
            global.c?.state.sgcd_pagePntKeys?.cm31cz10 == '10' // 閲覧タブ
          ,
          o_then: () => bf.q(`
            [it10l11e]="{}" AND 
            [it10l11k]="{}" AND 
            (
              [it10t110]="90" OR 
              (
                [it10t110]="30" AND 
                [it10b11k]="{}"
              ) OR 
              (
                [it10t110]="20" AND 
                [it10b31k]="{}"
              ) OR 
              (
                [it10t110]="10" AND 
                [it10b21k]="{}"
              )
            ) AND 
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            pd.tgt,
            pd.cm40_key || global.c?.state.sgc_pageKey,
            pd.cm20_key || global.c?.state.sgcd_pagePntKeys.cm20_key,
            pd.cm30_key || global.c?.state.sgcd_pagePntKeys.cm30_key,
            pd.cm10_key || global.c?.state.sgcd_pagePntKeys.cm10_key,
          )),
        },
      ]);
//bf.l('748: {}'.f(_r))
      break;
    case 'cndCt10':
      _r = bf.b([
/*
        {
          b_when: bf.i(global.c?.state.sgc_pageRole, ['own1']),
          o_then: () => bf.q(`
            [ct10l11e]="{}" AND 
            [ct10l11k]="{}" AND 
            (
              [ct10t110] IN ("90") 
            ) AND 
            IFNULL([ct10cz10],"10")<>"0"
          `.f(
            pd.tgt,
            global.c?.state.sgc_pageKey,
          )),
        },
        {
          b_when: bf.i(global.c?.state.sgc_pageRole, ['adm1', 'own2']),
          o_then: () => bf.q(`
            [ct10l11e]="{}" AND 
            [ct10l11k]="{}" AND 
            (
              [ct10t110]="90" OR 
              (
                [ct10t110]="30" AND 
                [ct10b21k]="{}"
              )
            ) AND 
            IFNULL([ct10cz10],"10")<>"0"
          `.f(
            pd.tgt,
            global.c?.state.sgc_pageKey,
            global.c?.state.sgcd_pagePntKeys.cm20_key,
          )),
        },
        {
          b_when: bf.i(global.c?.state.sgc_pageRole, ['mmb2', 'adm3', 'own4']),
          o_then: () => bf.q(`
            [ct10l11e]="{}" AND 
            [ct10l11k]="{}" AND 
            (
              [ct10t110]="90" OR 
              (
                [ct10t110]="30" AND 
                [ct10b21k]="{}"
              ) OR 
              (
                [ct10t110]="20" AND 
                [ct10b31k]="{}"
              )
            ) AND 
            IFNULL([ct10cz10],"10")<>"0"
          `.f(
            pd.tgt,
            global.c?.state.sgc_pageKey,
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            global.c?.state.sgcd_pagePntKeys.cm30_key,
          )),
        },
        {
          b_when: bf.i(global.c?.state.sgc_pageRole, ['mmb1', 'adm2', 'own3']),
          o_then: () => bf.q(`
            [ct10l11e]="{}" AND 
            [ct10l11k]="{}" AND 
            (
              [ct10t110]="90" OR 
              (
                [ct10t110]="30" AND 
                [ct10b21k]="{}"
              ) OR 
              (
                [ct10t110]="20" AND 
                [ct10b31k]="{}"
              ) OR
              (
                [ct10t110]="10" AND 
                [ct10b11k]="{}"
              )
            ) AND 
            [ct10t110]="{}" AND 
            IFNULL([ct10cz10],"10")<>"0"
          `.f(
            pd.tgt,
            global.c?.state.sgc_pageKey,
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            global.c?.state.sgcd_pagePntKeys.cm30_key,
            global.c?.state.sgcd_pagePntKeys.cm10_key,
          )),
        },

        {
          b_when: pd.t110 == '20',
          o_then: () => bf.q(`
            [ct10b21k]="{}" AND
            [ct10l11e]="{}" AND 
            [ct10l11k]="{}" AND 
            (
              [ct10t110]="20" AND 
              [ct10b31k]="{}"
            ) AND 
            IFNULL([ct10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            pd.tgt,
            global.c?.state.sgc_pageKey,
            global.c?.state.sgcd_pagePntKeys.cm30_key,
          )),
        },
*/
        {
          b_when: global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && pd.t110 == '20',
          o_then: () => bf.q(`
            [ct10b21k]="{}" AND
            [ct10l11e]="{}" AND 
            [ct10l11k]="{}" AND 
            (
              [ct10t110]="20"
            ) AND 
            IFNULL([ct10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            pd.tgt,
            global.c?.state.sgc_pageKey,
          )),
        },
        {
          b_when: global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && pd.t110 == '20',
          o_then: () => bf.q(`
            [ct10b21k]="{}" AND
            [ct10l11e]="{}" AND 
            [ct10l11k]="{}" AND 
            (
              [ct10t110]="20"
            ) AND 
            IFNULL([ct10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            pd.tgt,
            global.c?.state.sgc_pageKey,
          )),
        },
        {
          b_when: global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && pd.t110 == '10',
          o_then: () => bf.q(`
            [ct10b21k]="{}" AND
            [ct10l11e]="{}" AND 
            [ct10l11k]="{}" AND 
            (
              [ct10t110]="10"
            ) AND 
            IFNULL([ct10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            pd.tgt,
            global.c?.state.sgc_pageKey,
            global.c?.state.sgcd_pagePntKeys.cm10_key,
          )),
        },
        {
          b_when: global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && pd.t110 == '10',
          o_then: () => bf.q(`
            [ct10b21k]="{}" AND
            [ct10l11e]="{}" AND 
            [ct10l11k]="{}" AND 
            (
              [ct10t110]="10" AND 
              [ct10b11k]="{}"
            ) AND 
            IFNULL([ct10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            pd.tgt,
            global.c?.state.sgc_pageKey,
            global.c?.state.sgcd_pagePntKeys.cm10_key,
          )),
        },
      ]);
      break;
    default:
      bf.l('incorrect permission type')
      break;
  };
  return _r;
};

static $dd_subMenuss = {

  '部門CSV出力': {
    pfx: '部門 CSV出力',
    onPrs: () => {
      cf.myRN_eptCsv({
        name: '部門',
//        hdr: '"部門ID","部門","部門表示順","部門削除区分"',
        hdr: '"部門ID","部門","部門表示順","部門表示区分"',
        op_bldVal: _ld_valss => new Promise( _o_end1 => {
          global.c?.state.sld_cm30ss
          .map( async _d_cm30s => { // 画面に表示されているデータのみ出力
            let _d_vals = {
              cm30_key: _d_cm30s.val._KEY,
              cm30c310: _d_cm30s.val.cm30c310,
              cm30cx10: _d_cm30s.val.cm30cx10,
              cm30cz10: _d_cm30s.val.cm30cz10,
              cm30cw10: _d_cm30s.val.cm30cw10,
            };
            _ld_valss.push(_d_vals);
          });
          _o_end1();
        }),
        ld_sortss:[
          {fld:'cm30cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm30cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm30cw10', dtn:'asc', mode:'str'},
        ],
        o_listVal: _d_vals => [
          _d_vals.cm30cw10,
          _d_vals.cm30c310,
          _d_vals.cm30cx10,
//          (_d_vals.cm30cz10 == '0') ? '削除する' : '削除しない',
          (_d_vals.cm30cz10 == '0') ? '表示しない' : '表示する',
        ],
      });
    },
  },

  '部門CSV取込': {
    pfx: '部門 CSV取込',
    onPrs: () => {
//bf.l('886: {}'.f(global.c?.state.sgc_pageRole))
      cf.myRN_iptCsv({
        olp_chks: (_d_is, _d_rs) => [
          cf.myRN_chkIpt({
            name: '部門ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm30',
            o_cndElm: () => { // IDの抽出権限
              return bf.q('[cm30b11k]="{}" AND [cm30cw10]="{}"'.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['部門ID'],
              ));
            },
            l_insRoles: ['adm1', 'own2'], // 全社運営者のみ ins 可能
            l_updRoles: ['mmb1', 'adm1', 'own2', 'own3'],
            o_updCndCm31: 
              bf.i(global.c?.state.sgc_pageRole, ['adm1', 'own2']) ? 
                null
              :
                _d_cm30s => {
                  let _cnd = bf.q(`
                    [cm31b11k]="{}" AND 
                    [cm31b21k]="{}" AND 
                    [cm31b31k]="{}" AND 
                    [cm31c410]="20" AND 
                    IFNULL([cm31cz10],"10")<>"0"
                  `.f(
                    global.c?.state.sgcd_pagePntKeys.cm20_key,
                    _d_cm30s._KEY || '',
                    global.c?.state.sgcd_pagePntKeys.cm10_key,
                  ))
                  return _cnd;
                }
              ,
          }),

          cf.myRN_chkIpt({
            name: '部門表示順',
            type: '数値',
            d_is: _d_is,
            d_rs: _d_rs,
          }),

          cf.myRN_chkIpt({
//            name: '部門削除区分',
            name: '部門表示区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
//            l_is: ['削除する', '削除する']
            l_is: ['表示する', '表示しない']
          }),

        ],

        od_bldIuds: (_d_is, _d_rs) => {
          return { // 部門
            elm: 'cm30',
            od_insVals: _d_plts => ({
              cm30b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
              cm30c110: '',
              cm30c310: _d_is['部門'],
              cm30cx10: _d_is['部門表示順'] || '9999',
//              cm30cz10: (_d_is['部門削除区分'] == '削除する') ? '10' : '0',
              cm30cz10: (_d_is['部門表示区分'] == '表示する') ? '10' : '0',
              cm30cw10: _d_is['部門ID'] || bf.myCM_gnr(10),
            }),
            od_updVals: _d_plts => ({
              cm30c310: bf.f(_d_is['部門']) ? _d_is['部門'] : null,
              cm30cx10: bf.f(_d_is['部門表示順']) ? _d_is['部門表示順'] : null,
//              cm30cz10: bf.f(_d_is['部門削除区分']) ? ((_d_is['部門削除区分'] == '削除しない') ? '10' : '0') : null,
              cm30cz10: bf.f(_d_is['部門表示区分']) ? ((_d_is['部門表示区分'] == '表示する') ? '10' : '0') : null,
            }),
            o_cnd: _d_plts => bf.q(`
              [cm30b11k]="{}" AND 
              [cm30cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['部門ID']
            )),
            ld_cldss: [
            ],
          };
        },
      });
    },
  },

  '部門運営者CSV出力': {
    pfx: '部門運営者 CSV出力',
    onPrs: () => {
      cf.myRN_eptCsv({
        name: '部門運営者',
//        hdr: '"部門ID","部門","利用者ID","利用者","在籍区分","責任者削除区分"',
//        hdr: '"部門ID","部門","利用者ID","運営者","運営者削除区分"',
        hdr: '"部門ID","部門","利用者ID","運営者","運営者表示区分"',
        op_bldVal: _ld_valss => new Promise( async _o_end1 => {
//bf.l('858:here')
          await Promise.all(
            global.c?.state.sld_cm30ss
            .map( _d_cm30s => { // 画面に表示されているデータのみ出力
//bf.l('862: {}'.f(_d_cm30s))
              return new Promise( _o_end2 => {
                let _cnd = bf.q(`
                  [cm31b11k]="{}" AND 
                  [cm31b21k]="{}" AND 
                  IFNULL([cm31cz10],"10")<>"0"
                `.f(
                  global.c?.state.sgcd_pagePntKeys.cm20_key,
                  _d_cm30s.val._KEY
                ));
                cf.myCB_call_slc({
                  ctr: 'nlm',
                  elm: 'cm31',
                  n_dms: 3,
                  cnd: _cnd,
                  do_rfrs: {
                    cm10: _d_is => bf.q(`[_KEY]={}`.f(_d_is.cm31b31k)),
                    cm30: _d_is => bf.q(`[_KEY]={}`.f(_d_is.cm31b21k)),
                  },
                })
                .then( _ld_cm31ss => {
//bf.l('883: {}, {}'.f(_cnd, _ld_cm31ss))
                  _ld_cm31ss
                  .map( _d_cm31s => {
                    let _d_vals = {
                      cm30cz10: _d_cm31s.cm30cz10,
                      cm30cx10: _d_cm31s.cm30cx10,
                      cm30cw10: _d_cm31s.cm30cw10,
                      cm30c310: _d_cm31s.cm30c310,
                      cm10cz10: _d_cm31s.cm10cz10,
                      cm10cx10: _d_cm31s.cm10cx10,
                      cm10cw10: _d_cm31s.cm10cw10,
                      cm10c310: _d_cm31s.cm10c310,
                      cm31cz10: _d_cm31s.cm31cz10,
  //                    cm31c410: _d_cm31s.cm31c410,
                    };
                    _ld_valss.push(_d_vals);
//                    _o_end2();
                  });            
                  _o_end2();
                });
              });
            })
          )
          .then(() => {
//bf.l('903:{}'.f(_ld_valss))
            _o_end1();
          });
        }),
        ld_sortss:[
          {fld:'cm30cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm30cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm30cw10', dtn:'asc', mode:'str'},
          {fld:'cm10cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm31cz10', dtn:'desc', mode:'nmb'},
//          {fld:'cm31c410', dtn:'desc', mode:'nmb'},
          {fld:'cm10cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm10cw10', dtn:'asc', mode:'str'},
        ],
        o_listVal: _d_vals => {
          let _l = [
            _d_vals.cm30cw10,
            _d_vals.cm30c310,
            _d_vals.cm10cw10,
            _d_vals.cm10c310,
//            (_d_vals.cm31c410 == '20') ? '部門運営者' : '一般利用者',
//            (_d_vals.cm31cz10 == '0') ? '削除する' : '削除しない',
            (_d_vals.cm31cz10 == '0') ? '表示しない' : '表示する',
          ];
          return _l;
        },
      });
    },
  },

  '部門運営者CSV取込': {
    pfx: '部門運営者 CSV取込',
    onPrs: () => {
      cf.myRN_iptCsv({
        olp_chks: (_d_is, _d_rs) => [

          cf.myRN_chkIpt({
            name: '部門ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm30',
//            o_cndElm: _d_is => { // IDの抽出権限
            o_cndElm: () => { // IDの抽出権限
              return bf.q('[cm30b11k]="{}" AND [cm30cw10]="{}"'.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['部門ID'],
              ));
            },
            b_chkEtc: true,
            l_insRoles: null,
            l_updRoles: null,
            o_updCndCm31: _d_cm30s => { // IDに対する変更権限の有無
/*
              return bf.q(`
                [cm31b11k]="{}" AND 
                [cm31b21k]="{}" AND 
                [cm31b31k]="{}" AND 
                [cm31c410]="20" AND 
                IFNULL([cm31cz10],"10")<>"0"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_cm30s._KEY || '', // チェックシートの属する部門
                global.c?.state.sgcd_pagePntKeys.cm10_key,
              ))
*/
              return bf.q(`
                (
                  [cm31b11k]="{}" AND 
                  [cm31b21k]="{}" AND 
                  [cm31b31k]="{}" AND 
                  [cm31c410]="20" AND 
                  IFNULL([cm31cz10],"10")<>"0"
                ) OR
                "{}" IN ("20","90")
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_cm30s._KEY || '', // チェックシートの属する部門
                global.c?.state.sgcd_pagePntKeys.cm10_key,
                global.c?.state.sgcd_pagePntKeys.cm10c410,
              ))
            }
          }),

          cf.myRN_chkIpt({
            name: '利用者ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm10',
//            o_cndElm: _d_is => { // IDの抽出権限
            o_cndElm: () => { // IDの抽出権限
              return bf.q('[cm10b21k]="{}" AND [cm10cw10]="{}"'.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['利用者ID'],
              ));
            },
            b_chkEtc: true,
            l_insRoles: null,
            l_updRoles: null,
            o_updCndCm31: null,
          }),

/*
          cf.myRN_chkIpt({
            name: '在籍区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['部門運営者', '一般利用者'],
          }),
*/

/*
          cf.myRN_chkIpt({
            name: '運営者削除区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['削除しない', '削除する'],
          }),
*/
          cf.myRN_chkIpt({
            name: '運営者表示区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['表示する', '表示しない'],
          }),

        ],

        od_bldIuds: (_d_is, _d_rs) => {
          return { // アカウント
            elm: 'cm31',
            od_insVals: _d_plts => ({
//              cm31b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
              cm31b11k: global.c?.state.sgcd_pagePntKeys.cm20_key,
              cm31b21k: _d_rs.d_cm30s._KEY, 
              cm31b31k: _d_rs.d_cm10s._KEY,
              cm31c410: '20',
//              cm31cz10: (_d_is['運営者削除区分'] == '削除しない') ? '10' : '0',
              cm31cz10: (_d_is['運営者表示区分'] == '表示しない') ? '10' : '0',
            }),
            od_updVals: _d_plts => ({
/*
              cm10c310: bf.f(_d_is['氏名']) ? _d_is['氏名'] : null,
              cm10i110: bf.f(_d_is['メールアドレス']) ? _d_is['メールアドレス'] : null,
              cm10c410: bf.f(_d_is['利用区分']) ? ((_d_is['利用区分'] == '全社運営者') ? '20' : '10') : null,
              cm10cx10: bf.f(_d_is['利用者表示順']) ? _d_is['利用者表示順'] : null,
              cm10cz10: bf.f(_d_is['利用者削除区分']) ? ((_d_is['利用者削除区分'] == '削除しない') ? '10' : '0') : null,
*/
//              cm31b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
              cm31b11k: global.c?.state.sgcd_pagePntKeys.cm20_key,
              cm31b21k: _d_rs.d_cm30s._KEY, 
              cm31b31k: _d_rs.d_cm10s._KEY,
              cm31c410: '20',
//              cm31cz10: (_d_is['運営者削除区分'] == '削除しない') ? '10' : '0',
              cm31cz10: (_d_is['運営者表示区分'] == '表示しない') ? '10' : '0',
            }),
            o_cnd: _d_plts => bf.q(`
              [cm31b11k]="{}" AND 
              [cm31b21k]="{}" AND 
              [cm31b31k]="{}" 
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_rs.d_cm30s._KEY,
              _d_rs.d_cm10s._KEY,
            )),
            ld_cldss: [
            ],
          };
        },
      });
    },
  },

  '利用者CSV出力': {
    pfx: '利用者 CSV出力',
    onPrs: () => {
      cf.myRN_eptCsv({
        name: '利用者',
//        hdr: '"利用者ID","氏名","メールアドレス","役職","職種","生年月日","年齢","性別","利用区分","利用者表示順","利用者削除区分"',
        hdr: '"利用者ID","氏名","メールアドレス","役職","職種","生年月日","年齢","性別","利用区分","利用者表示順","利用者表示区分"',
        op_bldVal: _ld_valss => new Promise( async _o_end1 => {
          await Promise.all(
            global.c?.state.sld_cm10ss
            .map( _d_cm10s => { // 画面に表示されているデータのみ出力
              return new Promise( _o_end2 => {
                let _cnd = bf.q(`
                  [cm10b21k]="{}" AND
                  [_KEY]="{}"
                `.f(
                  global.c?.state.sgcd_pagePntKeys.cm20_key,
                  _d_cm10s.val._KEY
                ));
                cf.myCB_call_slc({
                  ctr: 'nlm',
                  elm: 'cm10',
                  n_dms: 3,
                  cnd: _cnd,
                  do_rfrs: {
                    cm11: _d_is => bf.q(`[cm11b11k]="{}"`.f(_d_is._KEY)),
                    cm1i: _d_is => bf.q(`[cm1ib11k]="{}"`.f(_d_is._KEY)),
                  },
                })
                .then( _ld_cm10ss => {
                  let _d_cm10s = _ld_cm10ss[0];
                  let _d_vals = {
                    cm10cz10: _d_cm10s.cm10cz10,
                    cm10cx10: _d_cm10s.cm10cx10,
                    cm10cw10: _d_cm10s.cm10cw10,
                    cm10c310: _d_cm10s.cm10c310,
                    cm10i110: _d_cm10s.cm10i110,
                    cm10c410: _d_cm10s.cm10c410,
                    cm11i210: _d_cm10s.cm11i210,
                    cm11i220: _d_cm10s.cm11i220,
                    cm11i310: _d_cm10s.cm11i310,
                    cm1ii210: _d_cm10s.cm1ii210,
                    cm1ii310: _d_cm10s.cm1ii310,
                  };
                  _ld_valss.push(_d_vals);
                  _o_end2();
                });
              });
            })
          )
          .then(() => {
            _o_end1();
          });
        }),
        ld_sortss:[
          {fld:'cm10cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm10cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm10cw10', dtn:'asc', mode:'str'},
        ],
        o_listVal: _d_vals => {
          let _l = [
            _d_vals.cm10cw10,
            _d_vals.cm10c310,
            _d_vals.cm10i110,
            _d_vals.cm1ii210,
            _d_vals.cm1ii310,
            _d_vals.cm11i210,
            _d_vals.cm11i220,
            (_d_vals.cm11i310 == '10') ? '男性' : '女性',
            (_d_vals.cm10c410 == '20') ? '全社運営者' : '部門運営者・一般利用者',
            _d_vals.cm10cx10,
//            (_d_vals.cm10cz10 == '0') ? '削除する' : '削除しない',
            (_d_vals.cm10cz10 == '0') ? '表示しない' : '表示する',
          ];
          return _l;
        },
      });
    },
  },

  '利用者CSV取込': {
    pfx: '利用者 CSV取込',
    onPrs: () => {
      cf.myRN_iptCsv({
        olp_chks: (_d_is, _d_rs) => [

          cf.myRN_chkIpt({
            name: '利用者ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm10',
            o_cndElm: () => { // IDの抽出権限
              return bf.q('[cm10b21k]="{}" AND [cm10cw10]="{}"'.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['利用者ID'],
              ));
            },
            l_insRoles: ['adm1', 'own2'], // 全体運営者のみ ins 可能
            l_updRoles: ['adm1', 'own2'],
            o_updCndCm31: null,
          }),

          cf.myRN_chkIpt({
            name: 'メールアドレス',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm10',
            o_cndElm: () => { // IDの抽出権限
              return bf.q('[cm10b21k]="{}" AND [cm10i110]="{}"'.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['メールアドレス'],
              ));
            },
            l_insRoles: ['adm1', 'own2'], // 全体運営者のみ ins 可能
            l_updRoles: ['adm1', 'own2'],
            o_updCndCm31: null,
          }),

          cf.myRN_chkIpt({
            name: '性別',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['男性', '女性'],
          }),

          cf.myRN_chkIpt({
            name: '利用区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['部門運営者・一般利用者', '全社運営者'],
          }),

          cf.myRN_chkIpt({
            name: '利用者表示順',
            type: '数値',
            d_is: _d_is,
            d_rs: _d_rs,
          }),

/*
          cf.myRN_chkIpt({
            name: '利用者削除区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['削除しない', '削除する'],
          }),
*/
          cf.myRN_chkIpt({
            name: '利用者表示区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['表示する', '表示しない'],
          }),

        ],

        od_bldIuds: (_d_is, _d_rs) => {
          return { // アカウント
            elm: 'cm10',
            od_insVals: _d_plts => ({
              cm10b11k: '',
              cm10b21k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
              cm10c110: '',
              cm10c310: _d_is['氏名'],
              cm10i110: _d_is['メールアドレス'],
              cm10c410: (_d_is['利用区分'] == '全社運営者') ? '20' : '10',
              cm10cx10: _d_is['利用者表示順'] || '9999',
//              cm10cz10: (_d_is['利用者削除区分'] == '削除しない') ? '10' : '0',
              cm10cz10: (_d_is['利用者表示区分'] == '表示する') ? '10' : '0',
              cm10cw10: _d_is['利用者ID'],
            }),
            od_updVals: _d_plts => ({
              cm10c310: bf.f(_d_is['氏名']) ? _d_is['氏名'] : null,
              cm10i110: bf.f(_d_is['メールアドレス']) ? _d_is['メールアドレス'] : null,
              cm10c410: bf.f(_d_is['利用区分']) ? ((_d_is['利用区分'] == '全社運営者') ? '20' : '10') : null,
              cm10cx10: bf.f(_d_is['利用者表示順']) ? _d_is['利用者表示順'] : null,
//              cm10cz10: bf.f(_d_is['利用者削除区分']) ? ((_d_is['利用者削除区分'] == '削除しない') ? '10' : '0') : null,
              cm10cz10: bf.f(_d_is['利用者表示区分']) ? ((_d_is['利用者表示区分'] == '表示する') ? '10' : '0') : null,
            }),
            o_cnd: _d_plts => bf.q(`
              [cm10b21k]="{}" AND 
              [cm10cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['利用者ID']
            )),
            ld_cldss: [
              { // アカウント
                elm: 'user',
                od_insVals: _d_plts => ({
                  user1010: _d_is['メールアドレス'],
                  user1020: bf.myCM_gnr(128),
                  user1030: _d_is['メールアドレス'],
                }),
                od_updVals: _d_plts => ({
                  user1010: bf.f(_d_is['メールアドレス']) ? _d_is['メールアドレス'] : null,
                  user1030: bf.f(_d_is['メールアドレス']) ? _d_is['メールアドレス'] : null,
                }),
                o_cnd: _d_plts => {
                  if ( bf.f(_d_plts.cm10b11k) ) { // user が登録済の場合
                    return bf.q(`
                      [_KEY]={} 
                    `.f(
                      _d_plts.cm10b11k
                    ));
                  }
                  else { // user が未登録の場合
                    return bf.q(`
                      [user1010]="{}" 
                    `.f(
                      _d_is['メールアドレス']
                    ));
                  };
                },
                ld_cldss: [
                  {
                    elm: 'cm10',
                    od_insVals: null, // 上書き更新のみ
                    od_updVals: _d_plts => ({
                      cm10b11k: bf.f(_d_plts._KEY) ? _d_plts._KEY : null,
                    }),
                    o_cnd: _d_plts => bf.q(`
                      [cm10b21k]="{}" AND 
                      [cm10i110]="{}"
                    `.f(
                      global.c?.state.sgcd_pagePntKeys.cm20_key,
                      _d_is['メールアドレス']
                    )),
                    ld_cldss: [
                    ],
                  },
                ],
              },
              { // 利用者属性 #1
                elm: 'cm11',
                od_insVals: _d_plts => ({
                  cm11b11k: _d_plts._KEY,
                  cm11i210: _d_is['生年月日'] || '',
                  cm11i220: _d_is['年齢'] || '',
                  cm11i310: (_d_is['性別'] == '男性') ? '10' : '20',
                }),
                od_updVals: _d_plts => ({
                  cm11i210: bf.f(_d_is['生年月日']) ? _d_is['生年月日'] : '',
                  cm11i220: bf.f(_d_is['年齢']) ? _d_is['年齢'] : '',
                  cm11i310: bf.f(_d_is['性別']) ? ((_d_is['性別'] == '男性') ? '10' : '20') : '',
                }),
                o_cnd: _d_plts => bf.q(`
                  [cm11b11k]="{}" 
                `.f(
                  _d_plts._KEY
                )),
                ld_cldss: [
                ],
              },
              { // 利用者属性 #i
                elm: 'cm1i',
                od_insVals: _d_plts => ({
                  cm1ib11k: _d_plts._KEY,
                  cm1ii210: _d_is['役職'] || '',
                  cm1ii310: _d_is['職種'] || '',
                }),
                od_updVals: _d_plts => ({
                  cm1ii210: bf.f(_d_is['役職']) ? _d_is['役職'] : '',
                  cm1ii310: bf.f(_d_is['職種']) ? _d_is['職種'] : '',
                }),
                o_cnd: _d_plts => bf.q(`
                  [cm1ib11k]="{}" 
                `.f(
                  _d_plts._KEY
                )),
                ld_cldss: [
                ],
              },
            ],
          };
        },
      });
    },
  },

  'チェックシート一覧CSV出力': {
    pfx: 'チェックシート一覧 CSV出力',
    onPrs: () => {
      cf.myRN_eptCsv({
        name: 'チェックシート一覧',
        hdr: '"部門ID","部門","業務ID","チェックシート","チェックシート表示順","チェックシート削除区分"',
//        hdr: '"部門ID","部門","業務ID","チェックシート","チェックシート削除区分"',
        op_bldVal: _ld_valss => new Promise( _o_end1 => {
          Promise.all(
            global.c?.state.sdld_cm30sss3.cm30
            .filter( _d_cm30s => ( bf.f(_d_cm30s.dld_cldDatsss?.cm40) == true ) ? true : false ) // チェックソートが登録されている部門のみ対象
            .map( async _d_cm30s => new Promise( _o_end2 => {
              _d_cm30s.dld_cldDatsss.cm40
              .map( _d_cm40s => {
                let _d_vals = {
                  cm30_key: _d_cm30s.d_flds._KEY,
                  cm30c310: _d_cm30s.d_flds.cm30c310,
                  cm30cx10: _d_cm30s.d_flds.cm30cx10,
                  cm30cz10: _d_cm30s.d_flds.cm30cz10,
                  cm30cw10: _d_cm30s.d_flds.cm30cw10,
                  cm40_key: _d_cm40s.d_flds._KEY,
                  cm40c310: _d_cm40s.d_flds.cm40c310,
                  cm40cx10: _d_cm40s.d_flds.cm40cx10,
                  cm40cz10: _d_cm40s.d_flds.cm40cz10,
                  cm40cw10: _d_cm40s.d_flds.cm40cw10,
                };
                _ld_valss.push(_d_vals);
                _o_end2();
              })
            }))
          )
          .then(() => {
            _o_end1();
          });
        }),
        ld_sortss:[
          {fld:'cm30cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm30cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm30cw10', dtn:'asc', mode:'str'},
          {fld:'cm30_key', dtn:'asc', mode:'nmb'},
          {fld:'cm40cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm40cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm40cw10', dtn:'asc', mode:'str'},
          {fld:'cm40_key', dtn:'asc', mode:'nmb'},
        ],
        o_listVal: _d_vals => [
          _d_vals.cm30cw10,
          _d_vals.cm30c310,
          _d_vals.cm40cw10,
          _d_vals.cm40c310,
          _d_vals.cm40cx10,
          (_d_vals.cm40cz10 == '0') ? '削除する' : '削除しない',
        ],
      });
    },
  },

  'チェックシート一覧CSV取込': {
    pfx: 'チェックシート一覧 CSV取込',
    onPrs: () => {
      cf.myRN_iptCsv({
        olp_chks: (_d_is, _d_rs) => [

          cf.myRN_chkIpt({
            name: '部門ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm30',
            o_cndElm: () => { // IDの抽出権限
              return bf.q(`
                [cm30b11k]="{}" AND 
                [cm30cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['部門ID'],
              ));
            },
            l_insRoles: null,
            l_updRoles: null,
            b_chkEtc: true,
            o_insCndCm31: null,
            o_updCndCm31: null,
          }),

          cf.myRN_chkIpt({
            name: '業務ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm40',
            o_cndElm: () => { // IDの抽出権限
              return bf.q(`
                [cm40b11k]="{}" AND 
                [cm40l11e]="mngSht" AND
                [cm40cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['業務ID'],
              ));
            },
            l_insRoles: ['mmb1', 'adm2', 'own3'],
            l_updRoles: ['mmb1', 'adm2', 'own3'],
            b_chkEtc: false,
            o_insCndCm31: () => {
              return bf.q(`
                [cm31b11k]="{}" AND 
                [cm31b21k]=(
                  SELECT 
                    [_KEY]::TEXT 
                  FROM 
                    [t_cm30] 
                  WHERE 
                    [cm30cw10]="{}"
                ) AND 
                [cm31b31k]="{}" AND 
                [cm31c410]="20" AND 
                IFNULL([cm31cz10],"10")<>"0"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['部門ID'], // チェックシートの属する部門
                global.c?.state.sgcd_pagePntKeys.cm10_key,
              ))
            },
            o_updCndCm31: _d_cm40s => { // IDに対する変更権限の有無
              return bf.q(`
                [cm31b11k]="{}" AND 
                [cm31b21k]="{}" AND 
                [cm31b31k]="{}" AND 
                [cm31c410]="20" AND 
                IFNULL([cm31cz10],"10")<>"0"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_cm40s.cm40b21k, // チェックシートの属する部門
                global.c?.state.sgcd_pagePntKeys.cm10_key,
              ))
            }
          }),

          cf.myRN_chkIpt({
            name: 'チェックシート表示順',
            type: '数値',
            d_is: _d_is,
            d_rs: _d_rs,
          }),

          cf.myRN_chkIpt({
            name: 'チェックシート削除',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['削除しない', '削除する'],
          }),

        ],
        od_bldIuds: (_d_is, _d_rs) => {
          return {
            elm: 'cm40',
            od_insVals: _d_plts => ({
              cm40b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
              cm40b21k: _d_rs.d_cm30s._KEY,
              cm40l11e: 'mngSht',
              cm40l11k: '2', // チェックシート
              cm40t110: ip.$o_pmn({ mode: 'type' }),
              cm40c110: '',
              cm40c310: _d_is['チェックシート'],
              cm40cx10: _d_is['チェックシート表示順'] || '9999',
              cm40cz10: (_d_is['チェックシート削除区分'] == '削除しない') ? '10' : '0',
              cm40cw10: _d_is['業務ID'],
            }),
            od_updVals: _d_plts => ({
              cm40c310: bf.f(_d_is['チェックシート']) ? _d_is['チェックシート'] : null,
              cm40cx10: bf.f(_d_is['チェックシート表示順']) ? _d_is['チェックシート表示順'] : null,
//              cm40cx10: 9999,
              cm40cz10: bf.f(_d_is['チェックシート削除区分']) ? ((_d_is['チェックシート削除区分'] == '削除しない') ? '10' : '0') : null,
//              cm40cz10: '10',
            }),
            o_cnd: _d_plts => bf.q(`
              [cm40b11k]="{}" AND 
              [cm40l11e]="mngSht" AND 
              [cm40cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['業務ID']
            )),
            ld_cldss: [
            ],
          };
        },
        op_atr: () => cf.myRN_set_pageMode('show'),
      });
    },
  },

  'チェックシート項目CSV出力': {
    pfx: 'チェックシート項目 CSV出力',
    onPrs: () => {
      cf.myRN_eptCsv({
        name: 'チェックシート項目',
        hdr: '"部門ID","部門","業務ID","チェックシート","チェック分類ID","チェック分類","チェック分類削除区分","チェック項目ID","チェック項目","チェック項目削除区分"',
        op_bldVal: _ld_valss => new Promise( _o_end1 => {
//bf.l('1862: here.')
          Promise.all(
            global.c?.state.sdld_cm30sss3.cm30
            .filter( _d_cm30s => ( bf.f(_d_cm30s.dld_cldDatsss?.cm40) == true ) ? true : false ) // チェックソートが登録されている部門のみ対象
            .map( async _d_cm30s => new Promise( _o_end2 => { 
//bf.l('1867: here.')
              Promise.all(
                _d_cm30s.dld_cldDatsss.cm40
                .map( _d_cm40s => new Promise( _o_end3 => { // mngSht
//bf.l('1871: here.')
                  let _cnd = bf.q(`
                    [cm40b11k]="{}" AND 
                    [cm40l11e]="mngCtg" AND
                    [cm40l11k]="{}" AND
                    IFNULL([cm40cz10],"10")<>"0"
                  `.f(
                    global.c?.state.sgcd_pagePntKeys.cm20_key,
                    _d_cm40s.d_flds._KEY
                  ));
                  cf.myCB_call_slc({
                    ctr: 'nlm',
                    elm: 'cm40',
                    n_dms: 3,
                    cnd: _cnd,
                  })
                  .then( _ld_mngCtgss => { // mngCtg
//bf.l('1888: here.')
                    Promise.all(
                      _ld_mngCtgss
                      .map( _d_mngCtgs => new Promise( _o_end4 => {
//bf.l('1892: here.')
                        let _cnd = bf.q(`
                          [it10b11k]="{}" AND 
                          [it10l11e]="mngChk" AND
                          [it10l11k]="{}" AND 
                          IFNULL([it10cz10],"10")<>"0"
                        `.f(
                          global.c?.state.sgcd_pagePntKeys.cm20_key,
                          _d_mngCtgs._KEY
                        ));
                        cf.myCB_call_slc({
                          ctr: 'nlm',
                          elm: 'it10',
                          n_dms: 3,
                          cnd: _cnd,
                        })
                        .then( _ld_it10ss => { // mngChk
//bf.l('1909: here.')
                          _ld_it10ss
                          .map( _d_it10s => {
                            let _d_vals = {
                              cm30cz10: _d_cm30s.d_flds.cm30cz10,
                              cm30cx10: _d_cm30s.d_flds.cm30cx10,
                              cm30cw10: _d_cm30s.d_flds.cm30cw10,
                              cm30c310: _d_cm30s.d_flds.cm30c310,
                              cm30_key: _d_cm30s.d_flds._KEY,
                              cm40cz10: _d_cm40s.d_flds.cm40cz10,
                              cm40cx10: _d_cm40s.d_flds.cm40cx10,
                              cm40cw10: _d_cm40s.d_flds.cm40cw10,
                              cm40c310: _d_cm40s.d_flds.cm40c310,
                              cm40_key: _d_cm40s.d_flds._KEY,
                              cm402cz10: _d_mngCtgs.cm40cz10,
                              cm402cx10: _d_mngCtgs.cm40cx10,
                              cm402cw10: _d_mngCtgs.cm40cw10,
                              cm402c310: _d_mngCtgs.cm40c310,
                              cm402_key: _d_mngCtgs.cm40_key,
                              it10cz10: _d_it10s.it10cz10,
                              it10cx10: _d_it10s.it10cx10,
                              it10cw10: _d_it10s.it10cw10,
                              it10c310: _d_it10s.it10c310,
                              it10_key: _d_it10s.it10_key,
                            };
                            _ld_valss.push(_d_vals);
//bf.l('1935: here.')
                          });
                          _o_end4();
                        });
                      }))
                    )
                    .then(() => {
//bf.l('1942: here.')
                      _o_end3();
                    })
                  });
                }))
              )
              .then(() => {
//bf.l('1949: here.')
                _o_end2();
              });
            }))
          )
          .then(() => {
//bf.l('1955: here.')
            _o_end1();
          })
        }),
        ld_sortss:[
          {fld:'cm30cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm30cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm30cw10', dtn:'asc', mode:'str'},
          {fld:'cm30_key', dtn:'asc', mode:'nmb'},
          {fld:'cm40cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm40cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm40cw10', dtn:'asc', mode:'str'},
          {fld:'cm40_key', dtn:'asc', mode:'nmb'},
          {fld:'cm402cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm402cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm402cw10', dtn:'asc', mode:'str'},
          {fld:'cm402_key', dtn:'asc', mode:'nmb'},
          {fld:'it10cz10', dtn:'desc', mode:'nmb'},
          {fld:'it10cx10', dtn:'asc', mode:'nmb'},
          {fld:'it10cw10', dtn:'asc', mode:'str'},
          {fld:'it10_key', dtn:'asc', mode:'nmb'},
        ],
        o_listVal: _d_vals => [
          _d_vals.cm30cw10,
          _d_vals.cm30c310,
          _d_vals.cm40cw10,
          _d_vals.cm40c310,
          _d_vals.cm402cw10,
          _d_vals.cm402c310,
          (_d_vals.cm402cz10 == '10') ? '削除しない' : '削除する',
          _d_vals.it10cw10,
          _d_vals.it10c310,
          (_d_vals.it10cz10 == '10') ? '削除しない' : '削除する',
        ],
      });
    },
  },

  'チェックシート項目CSV取込': {
    pfx: 'チェックシート項目 CSV取込',
    onPrs: () => {
      cf.myRN_iptCsv({

        olp_bfrs: (_d_is, _d_rs, _dd_cashss) => [
          new Promise( _o_end1 => {
            let _o_cnd1 = _d_pnts => bf.q(`
              [cm40b11k]="{}" AND
              [cm40l11e]="mngSht" AND 
              [cm40cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['業務ID'],
            ));
//bf.l('2008: here')
            cf.myCB_call_tree({
              ctr: 'slc',
              dd_elmDefss: {
                mngSht: {
                  ctr: 'slc',
                  elm: 'cm40',
                  n_dms: 2,
                  o_cnd: _o_cnd1,
                  d_clds: {
                  }
                }
              },
              dd_cashs: _dd_cashss,
            })
            .then( _res => {
//bf.l('2024: {}'.f(_res))
              _d_rs.d_rfrs.mngSht = _res.mngSht || { d_flds: {
                _KEY: -1,
                cm40b21k: '-1', 
              }};          
//bf.l('2026: here')
              _o_end1();
            })
          }),
        ],

        olp_chks: (_d_is, _d_rs, _dd_cashss) => [

          cf.myRN_chkIpt({
            name: '業務ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm40',
            b_chkEtc: true,
            o_cndElm: () => { // IDの抽出権限
              return bf.q(`
                [cm40b11k]="{}" AND 
                [cm40l11e]="mngSht" AND 
                [cm40cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['業務ID'],
              ));
            },
            o_insCndCm31: null,
            o_updCndCm31: null,
          }),

          cf.myRN_chkIpt({
            name: 'チェック分類ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            dd_cashss: _dd_cashss,
            elm: 'cm40',
            o_cndElm: () => { // IDの抽出権限
              let _cnd = bf.q(`
                [cm40b11k]="{}" AND 
                [cm40l11e]="mngCtg" AND 
                [cm40l11k]="{}" AND
                [cm40cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.mngSht.d_flds._KEY,
                _d_is['チェック分類ID'],
              ));
              return _cnd;
            },
            o_insCndCm31: () => {
              let _cnd = bf.q(`
                [cm31b11k]="{}" AND 
                [cm31b21k]="{}" AND 
                [cm31b31k]="{}" AND 
                [cm31c410]="20" AND 
                IFNULL([cm31cz10],"10")<>"0"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.mngSht.d_flds.cm40b21k,
                global.c?.state.sgcd_pagePntKeys.cm10_key,
              ));
//bf.l('2090: {}'.f(_cnd))
              return _cnd;
            },
            o_updCndCm31: _d_cm40s => { // IDに対する変更権限の有無
              let _cnd = bf.q(`
                [cm31b11k]="{}" AND 
                [cm31b21k]="{}" AND 
                [cm31b31k]="{}" AND 
                [cm31c410]="20" AND 
                IFNULL([cm31cz10],"10")<>"0"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.mngSht.d_flds.cm40b21k,
                global.c?.state.sgcd_pagePntKeys.cm10_key,
              ))
              return _cnd;
            }
          }),

          cf.myRN_chkIpt({
            name: 'チェック分類削除区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['削除しない', '削除する'],
          }),

          cf.myRN_chkIpt({
            name: 'チェック項目ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            dd_cashss: _dd_cashss,
            elm: 'it10',
            o_cndElm: () => { // IDの抽出権限
              return bf.q(`
                [it10l11e]="mngChk" AND
                [it10l11k]=(
                  SELECT 
                    [A].[_KEY]::TEXT 
                  FROM 
                    [t_cm40] AS [A]
                  WHERE 
                    [A].[cm40l11e]="mngCtg" AND 
                    [A].[cm40l11k]="{}" AND
                    [A].[cm40b11k]="{}" AND 
                    [A].[cm40cw10]="{}"
                ) AND 
                [it10b11k]="{}" AND 
                [it10cw10]="{}"
              `.f(
                _d_rs.d_rfrs.mngSht.d_flds._KEY,
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['チェック分類ID'],
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['チェック項目ID'],
              ));
            },
            o_insCndCm31: () => bf.q(`
              [cm31b11k]="{}" AND 
              [cm31b21k]="{}" AND 
              [cm31b31k]="{}" AND 
              [cm31c410]="20" AND 
              IFNULL([cm31cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_rs.d_rfrs.mngSht.d_flds.cm40b21k,
              global.c?.state.sgcd_pagePntKeys.cm10_key,
            )),
            o_updCndCm31: _d_it10s => { // IDに対する変更権限の有無
              return bf.q(`
                [cm31b11k]="{}" AND 
                [cm31b21k]="{}" AND 
                [cm31b31k]="{}" AND 
                [cm31c410]="20" AND 
                IFNULL([cm31cz10],"10")<>"0"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.mngSht.d_flds.cm40b21k,
                global.c?.state.sgcd_pagePntKeys.cm10_key,
              ))
            }
          }),

          cf.myRN_chkIpt({
            name: 'チェック項目削除区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['削除しない', '削除する'],
          }),

        ],

        od_bldIuds: (_d_is, _d_rs) => {
//bf.l('2176: here')
          return { // チェック分類
            elm: 'cm40',
            od_insVals: _d_plts => ({
              cm40b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
              cm40b21k: _d_rs.d_rfrs.mngSht.d_flds.cm40b21k,
              cm40l11e: 'mngCtg',
              cm40l11k: _d_rs.d_rfrs.mngSht.d_flds._KEY, // チェックシート
              cm40t110: ip.$o_pmn({ mode: 'type' }),
              cm40c110: '',
              cm40c310: _d_is['チェック分類'],
              cm40cw10: _d_is['チェック分類ID'],
              cm40cx10: _d_is['チェック分類表示順'] || '9999',
              cm40cz10: (_d_is['チェック分類削除区分'] == '削除しない') ? '10' : '0',
            }),
            od_updVals: _d_plts => ({
              cm40c310: bf.f(_d_is['チェック分類']) ? _d_is['チェック分類'] : null,
              cm40cz10: bf.f(_d_is['チェック分類削除区分']) ? ((_d_is['チェック分類削除区分'] == '削除しない') ? '10' : '0') : null,
              cm40cx10: bf.f(_d_is['チェック分類表示順']) ? _d_is['チェック分類表示順'] : null,
            }),
            o_cnd: _d_plts => bf.q(`
              [cm40l11e]="mngCtg" AND 
              [cm40l11k]="{}" AND 
              [cm40b11k]="{}" AND 
              [cm40cw10]="{}"
            `.f(
              _d_rs.d_rfrs.mngSht.d_flds._KEY,
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['チェック分類ID']
            )),
            ld_cldss: [
              { // チェック項目
                elm: 'it10',
                od_insVals: _d_plts => ({
                  it10b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
                  it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key,
                  it10b31k: _d_rs.d_rfrs.mngSht.d_flds.cm40b21k,
                  it10l11e: 'mngChk',
                  it10l11k: _d_plts._KEY,
                  it10c110: '',
                  it10t110: ip.$o_pmn({ mode: 'type' }),
                  it10c310: _d_is['チェック項目'],
                  it10cw10: _d_is['チェック項目ID'],
                  it10cx10: _d_is['チェック項目表示順'] || '9999',
                  it10cz10: (_d_is['チェック項目削除区分'] == '削除しない') ? '10' : '0',
                }),
                od_updVals: _d_plts => ({
                  it10c310: bf.f(_d_is['チェック項目']) ? _d_is['チェック項目'] : null,
                  it10cz10: bf.f(_d_is['チェック項目削除区分']) ? ((_d_is['チェック項目削除区分'] == '削除しない') ? '10' : '0') : null,
                  it10cx10: bf.f(_d_is['チェック項目表示順']) ? _d_is['チェック項目表示順'] : null,
                }),
                o_cnd: _d_plts => bf.q(`
                  [it10l11e]="mngChk" AND
                  [it10l11k]=(
                    SELECT 
                      [A].[_KEY]::TEXT 
                    FROM 
                      [t_cm40] AS [A]
                    WHERE 
                      [A].[cm40l11e]="mngCtg" AND 
                      [A].[cm40l11k]="{}" AND
                      [A].[cm40b11k]="{}" AND 
                      [A].[cm40cw10]="{}"
                  ) AND 
                  [it10b11k]="{}" AND 
                  [it10cw10]="{}"
                `.f(
                  _d_rs.d_rfrs.mngSht.d_flds._KEY,
                  global.c?.state.sgcd_pagePntKeys.cm20_key,
                  _d_is['チェック分類ID'],
                  global.c?.state.sgcd_pagePntKeys.cm20_key,
                  _d_is['チェック項目ID'],
                )),
                ld_cldss: [
                ],
              },
            ],
          };
        },
        op_atr: () => cf.myRN_set_pageMode('show'),
      });
    },
  },

  'チェックシート回答CSV出力': {
    pfx: 'チェックシート回答 CSV出力',
    onPrs: () => {
      cf.myRN_eptCsv({
        name: 'チェックシート回答',
        hdr: '"部門ID","部門","業務ID","チェックシート","チェック分類ID","チェック分類","チェック項目ID","チェック項目","利用者ID","回答者","回答日","回答"',
        op_bldVal: (_ld_valss, _dd_cashss) => new Promise( _o_end1 => {

          let _o_cndCm30 = _d_pnts => {
            let _cnd = bf.q(`
              [cm30b11k]="{}" AND
              [_KEY] IN (
                SELECT
                  [cm31b21k]::NUMERIC::INTEGER
                FROM
                  [t_cm31]
                WHERE
                  [cm31b11k]="{}" AND
                  [cm31b31k]="{}" AND
                  IFNULL([cm31cz10],"10")<>"0"
              ) AND
              IFNULL([cm30cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              global.c?.state.sgcd_pagePntKeys.cm10_key,
            ));

            return _cnd;
          };

          let _o_cndMngSht = _d_pnts => {
            let _cnd = bf.q(`
              [cm40b11k]="{}" AND
              [cm40b21k]="{}" AND
              [cm40l11e]="mngSht" AND
              IFNULL([cm40cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_pnts.cm30.d_flds._KEY,
            ));
            return _cnd;
          };

          let _o_cndMngTgt = _d_pnts => {
            let _cnd = bf.q(`
              [it20b11k]="{}" AND
              [it20b21k]="{}" AND
              IFNULL([it20cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_pnts.mngSht.d_flds._KEY,
            ));
            return _cnd;
          };

          let _o_cndMngCtg = _d_pnts => {
            let _cnd = bf.q(`
              [cm40b11k]="{}" AND
              [cm40l11e]="mngCtg" AND
              [cm40l11k]="{}" AND
              IFNULL([cm40cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_pnts.mngSht.d_flds._KEY,
            ));
            return _cnd;
          };

          let _o_cndMngChk = _d_pnts => {
            let _cnd = bf.q(`
              [it10b11k]="{}" AND
              [it10l11e]="mngChk" AND
              [it10l11k]="{}" AND
              IFNULL([it10cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_pnts.mngCtg.d_flds._KEY,
            ));
            return _cnd;
          };

          let _o_cndMngAsr = _d_pnts => {
            let _cnd = bf.q(`
              [it30b11k]="{}" AND
              [it30b21k]="{}" AND
              [it30b31k]="{}" AND
              [it30b41k]="{}" AND
              IFNULL([it30cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_pnts.mngSht.d_flds._KEY,
              _d_pnts.mngTgt.d_flds._KEY,
              _d_pnts.mngChk.d_flds._KEY,
            ));
            return _cnd;
          };

          let _o_cndCm10 = _d_flds => {
            let _cnd = bf.q(`
              [cm10b21k]="{}" AND
              [_KEY]={}
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_flds.it30b51k,
            ));
            return _cnd;
          };

          cf.myCB_call_tree({
            ctr: 'slc',
            dd_elmDefss: {
              cm30: { // 部門
                elm: 'cm30',
                o_cnd: _o_cndCm30,
                dd_cldDefss: {
                  mngSht: { // チェックシート
                    elm: 'cm40',
                    o_cnd: _o_cndMngSht,
                    dd_cldDefss: {
                      mngTgt: { // 回答対象
                        elm: 'it20',
                        o_cnd: _o_cndMngTgt,
                        dd_cldDefss: {
                          mngCtg: { // チェック分類
                            elm: 'cm40',
                            o_cnd: _o_cndMngCtg,
                            dd_cldDefss: {
                              mngChk: { // チェック項目
                                elm: 'it10',
                                o_cnd: _o_cndMngChk,
                                dd_cldDefss: {
                                  mngAsr: { // 回答
                                    elm: 'it30',
                                    o_cnd: _o_cndMngAsr,
                                    op_act: (_dd_datss) => new Promise( _o_end2 => {
                                      let _d = {
                                        cm30cz10: _dd_datss.cm30.d_flds.cm30cz10,
                                        cm30cx10: _dd_datss.cm30.d_flds.cm30cx10,
                                        cm30cw10: _dd_datss.cm30.d_flds.cm30cw10,
                                        cm30c310: _dd_datss.cm30.d_flds.cm30c310,
                                        cm10cz10: _dd_datss.mngAsr.d_flds.cm10cz10,
                                        cm10cx10: _dd_datss.mngAsr.d_flds.cm10cx10,
                                        cm10cw10: _dd_datss.mngAsr.d_flds.cm10cw10,
                                        cm10_key: _dd_datss.mngAsr.d_flds.cm10_key,
                                        cm10c310: _dd_datss.mngAsr.d_flds.cm10c310,
                                        mngTgtC310: _dd_datss.mngTgt.d_flds.it20c310,
                                        mngShtCz10: _dd_datss.mngSht.d_flds.cm40cz10,
                                        mngShtCx10: _dd_datss.mngSht.d_flds.cm40cx10,
                                        mngShtCw10: _dd_datss.mngSht.d_flds.cm40cw10,
                                        mngSht_key: _dd_datss.mngSht.d_flds._KEY,
                                        mngShtC310: _dd_datss.mngSht.d_flds.cm40c310,
                                        mngCtgCz10: _dd_datss.mngCtg.d_flds.cm40cz10,
                                        mngCtgCx10: _dd_datss.mngCtg.d_flds.cm40cx10,
                                        mngCtgCw10: _dd_datss.mngCtg.d_flds.cm40cw10,
                                        mngCtg_key: _dd_datss.mngCtg.d_flds._KEY,
                                        mngCtgC310: _dd_datss.mngCtg.d_flds.cm40c310,
                                        mngChkCz10: _dd_datss.mngChk.d_flds.it10cz10,
                                        mngChkCx10: _dd_datss.mngChk.d_flds.it10cx10,
                                        mngChkCw10: _dd_datss.mngChk.d_flds.it10cw10,
                                        mngChk_key: _dd_datss.mngChk.d_flds._KEY,
                                        mngChkC310: _dd_datss.mngChk.d_flds.it10c310,
                                        mngAsrC610: _dd_datss.mngAsr.d_flds.it30c610,
                                      };
                                      _ld_valss.push(_d)
                                      _o_end2();
                                    }),
                                    dd_rfrss: {
                                      cm10: { // 在籍者
                                        elm: 'cm10',
                                        o_cnd: _o_cndCm10,
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
            dd_cashss: _dd_cashss,
          })
          .then( () => {
            _o_end1();
          });
        }),
        ld_sortss:[
          {fld:'cm30cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm30cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm30cw10', dtn:'asc', mode:'str'},
          {fld:'cm30_key', dtn:'asc', mode:'nmb'},
          {fld:'cm10cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm10cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm10cw10', dtn:'asc', mode:'str'},
          {fld:'cm10_key', dtn:'asc', mode:'nmb'},
          {fld:'mngTgtC310', dtn:'asc', mode:'str'},
          {fld:'mngShtCz10', dtn:'desc', mode:'nmb'},
          {fld:'mngShtCx10', dtn:'asc', mode:'nmb'},
          {fld:'mngShtCw10', dtn:'asc', mode:'str'},
          {fld:'mngSht_key', dtn:'asc', mode:'nmb'},
          {fld:'mngCtgCz10', dtn:'desc', mode:'nmb'},
          {fld:'mngCtgCx10', dtn:'asc', mode:'nmb'},
          {fld:'mngCtgCw10', dtn:'asc', mode:'str'},
          {fld:'mngCtg_key', dtn:'asc', mode:'nmb'},
          {fld:'mngChkCz10', dtn:'desc', mode:'nmb'},
          {fld:'mngChkCx10', dtn:'asc', mode:'nmb'},
          {fld:'mngChkCw10', dtn:'asc', mode:'str'},
          {fld:'mngChk_key', dtn:'asc', mode:'nmb'},
        ],
        o_listVal: _d_vals => [
          _d_vals.cm30cw10,
          _d_vals.cm30c310,
          _d_vals.mngShtCw10,
          _d_vals.mngShtC310,
          _d_vals.mngCtgCw10,
          _d_vals.mngCtgC310,
          _d_vals.mngChkCw10,
          _d_vals.mngChkC310,
          _d_vals.cm10cw10,
          _d_vals.cm10c310,
          _d_vals.mngTgtC310,
          bf.b([
            {
              b_when: _d_vals.mngAsrC610 == '1',
              o_then: () => '特にそう思う',
            },
            {
              b_when: _d_vals.mngAsrC610 == '2',
              o_then: () => 'そう思う',
            },
            {
              b_when: _d_vals.mngAsrC610 == '3',
              o_then: () => 'あまりそう思わない',
            },
            {
              b_when: _d_vals.mngAsrC610 == '4',
              o_then: () => '全くそう思わない',
            },
            {
              o_else: () => '未選択',
            }
          ]),
        ],
      });
    },
  },

  'チェックシート回答CSV取込': {
    pfx: 'チェックシート回答 CSV取込',
    onPrs: () => {
      cf.myRN_iptCsv({
        olp_bfrs: (_d_is, _d_rs, _dd_cashss) => [ // 事前登録されているものが対象

         new Promise( _o_end1 => {

            let _o_cndMngSht = _d_pnts => bf.q(`
              [cm40b11k]="{}" AND
              [cm40l11e]="mngSht" AND 
              [cm40cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['業務ID'],
            ));

            let _o_cndMngCtg = _d_pnts => bf.q(`
              [cm40b11k]="{}" AND
              [cm40l11e]="mngCtg" AND 
              [cm40l11k]="{}" AND 
              [cm40cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_pnts.mngSht.d_flds._KEY,
              _d_is['チェック分類ID'],
            ));

            let _o_cndMngChk = _d_pnts => bf.q(`
              [it10b11k]="{}" AND
              [it10l11e]="mngChk" AND 
              [it10l11k]="{}" AND 
              [it10cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_pnts.mngCtg.d_flds._KEY,
              _d_is['チェック項目ID'],
            ));

            let _o_cndCm10 = _d_pnts => bf.q(`
              [cm10b21k]="{}" AND
              [cm10cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['利用者ID'],
            ));

            cf.myCB_call_tree({
              ctr: 'slc',
              dd_cashs: _dd_cashss,
              dd_elmDefss: {
                mngSht: {
                  elm: 'cm40',
                  o_cnd: _o_cndMngSht,
                  dd_cldDefss: {
                    mngCtg: {
                      elm: 'cm40',
                      o_cnd: _o_cndMngCtg,
                      dd_cldDefss: {
                        mngChk: {
                          elm: 'it10',
                          o_cnd: _o_cndMngChk,
                          op_act: (_dd_datss) => new Promise( _o_end2 => {
                            _d_rs.d_rfrs.mngSht = _dd_datss.mngSht;
                            _d_rs.d_rfrs.mngCtg = _dd_datss.mngCtg;
                            _d_rs.d_rfrs.mngChk = _dd_datss.mngChk;
                            _o_end2();
                          }),
                        }
                      }
                    }
                  }
                },
                cm10: {
                  elm: 'cm10',
                  o_cnd: _o_cndCm10,
                  op_act: (_dd_datss) => new Promise( _o_end2 => {
                    _d_rs.d_rfrs.cm10 = _dd_datss.cm10;
                    _o_end2();
                  }),
                },
              },
            })
            .then( _res => {
              _o_end1();
            })
          }),
        ],

        olp_chks: (_d_is, _d_rs, _dd_cashss) => [

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '業務ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm40',
            b_chkEtc: true,
            o_cndElm: () => { // IDの抽出権限
              return bf.q(`
                [cm40b11k]="{}" AND 
                [cm40l11e]="mngSht" AND 
                [cm40cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['業務ID'],
              ));
            },
            l_insRoles: null,
            o_insCndCm31: null,
            l_updRoles: null,
            o_updCndCm31: null,
          }),

          cf.myRN_chkIpt({ // 取込者が業務IDで指定された部門に対する部門運営者であることを確認
            dd_cashss: _dd_cashss,
            name: '業務ID',
            type: '部門運営者',
            d_is: _d_is,
            d_rs: _d_rs,
            b_chk: bf.i(global.c?.state.sgc_pageRole, ['mmb1', 'adm2', 'own3']),
            cm30_key: _d_rs.d_rfrs.mngSht.d_flds.cm40b21k || -1,
          }),

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: 'チェック分類ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm40',
            b_chkEtc: true,
            o_cndElm: () => { // IDの抽出権限
              return bf.q(`
                [cm40b11k]="{}" AND 
                [cm40l11e]="mngCtg" AND 
                [cm40l11k]="{}" AND 
                [cm40cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.mngSht.d_flds._KEY || -1,
                _d_is['チェック分類ID'],
              ));
            },
            l_insRoles: null,
            o_insCndCm31: null,
            l_updRoles: null,
            o_updCndCm31: null,
          }),

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: 'チェック項目ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'it10',
            b_chkEtc: true,
            o_cndElm: () => { // IDの抽出権限
              return bf.q(`
                [it10b11k]="{}" AND 
                [it10l11e]="mngChk" AND 
                [it10l11k]="{}" AND 
                [it10cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.mngCtg.d_flds._KEY || -1,
                _d_is['チェック項目ID'],
              ));
            },
            l_insRoles: null,
            o_insCndCm31: null,
            l_updRoles: null,
            o_updCndCm31: null,
          }),

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '利用者ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm10',
            b_chkEtc: true,
            o_cndElm: () => { // IDの抽出権限
              let _cnd = bf.q(`
                [cm10b21k]="{}" AND 
                [cm10cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['利用者ID'],
              ));
              return _cnd;
            },
            o_insCndCm31: null,
            o_updCndCm31: null,
          }),

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '回答',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['特にそう思う', 'そう思う', 'あまりそう思わない', '全くそう思わない', '未選択'],
          }),

        ],

        od_bldIuds: (_d_is, _d_rs) => {
          return { // チェック対象
            elm: 'it20',
            od_insVals: _d_plts => ({
              it20b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
              it20b21k: _d_rs.d_rfrs.mngSht.d_flds._KEY,
              it20c310: _d_is['回答日'],
            }),
            od_updVals: null,
            o_cnd: _d_plts => {
              let _cnd = bf.q(`
                [it20b11k]="{}" AND 
                [it20b21k]="{}" AND 
                [it20c310]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.mngSht.d_flds._KEY,
                _d_is['回答日']
              ));
              return _cnd;
            },
            ld_cldss: [
              { // チェック回答
                elm: 'it30',
                od_insVals: _d_plts => ({
                  it30b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
                  it30b21k: _d_rs.d_rfrs.mngSht.d_flds._KEY,
                  it30b31k: _d_plts._KEY,
                  it30b41k: _d_rs.d_rfrs.mngChk.d_flds._KEY,
                  it30b51k: _d_rs.d_rfrs.cm10.d_flds._KEY,
                  it30c610: bf.b([
                    {
                      b_when: _d_is['回答'] == '特にそう思う',
                      o_then: () => '4', 
                    },
                    {
                      b_when: _d_is['回答'] == 'そう思う',
                      o_then: () => '3', 
                    },
                    {
                      b_when: _d_is['回答'] == 'あまりそう思わない',
                      o_then: () => '2', 
                    },
                    {
                      b_when: _d_is['回答'] == '全くそう思わない',
                      o_then: () => '1', 
                    },
                    {
                      o_else: () => '0', 
                    },
                  ]),
                }),
                od_updVals: _d_plts => ({
                  it30c610: bf.b([
                    {
                      b_when: _d_is['回答'] == '特にそう思う',
                      o_then: () => '4', 
                    },
                    {
                      b_when: _d_is['回答'] == 'そう思う',
                      o_then: () => '3', 
                    },
                    {
                      b_when: _d_is['回答'] == 'あまりそう思わない',
                      o_then: () => '2', 
                    },
                    {
                      b_when: _d_is['回答'] == '全くそう思わない',
                      o_then: () => '1', 
                    },
                    {
                      o_else: () => '0', 
                    },
                  ]),
                }),
                o_cnd: _d_plts => {
                  let _cnd = bf.q(`
                    [it30b11k]="{}" AND
                    [it30b21k]="{}" AND
                    [it30b31k]="{}" AND
                    [it30b41k]="{}" AND
                    [it30b51k]="{}"
                  `.f(
                    global.c?.state.sgcd_pagePntKeys.cm20_key,
                    _d_rs.d_rfrs.mngSht.d_flds._KEY,
                    _d_plts._KEY,
                    _d_rs.d_rfrs.mngChk.d_flds._KEY,
                    _d_rs.d_rfrs.cm10.d_flds._KEY,
                  ));
                  return _cnd;
                },
                ld_cldss: [
                ],
              },
            ],
          };
        },
        op_atr: () => cf.myRN_set_pageMode('show'),
      });
    },
  },

  'チェックシート事例CSV出力': {
    pfx: 'チェックシート事例 CSV出力',
    onPrs: () => {
      cf.myRN_eptCsv({
        name: 'チェックシート事例',
//        hdr: '"部門ID","部門","業務ID","チェックシート","事例ID","事例","事例削除区分","事例区分"',
        hdr: '"部門ID","部門","業務ID","チェックシート","事例ID","事例","事例削除区分","事例区分","利用者ID","事例登録者"',
        op_bldVal: (_ld_valss, _dd_cashss) => new Promise( _o_end1 => {
          let _o_cndCm31 = _dd_datss => { // 自身が属している全部門
            let _cnd = bf.q(`
              [cm31b11k]="{}" AND 
              [cm31b31k]="{}" AND 
              IFNULL([cm31cz10],"10")<>"0" 
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              global.c?.state.sgcd_pagePntKeys.cm10_key,
            ));
            return _cnd;
          };
          let _o_cndCm30 = _dd_datss => {
            let _cnd = bf.q(`
              [cm30b11k]="{}" AND 
              [_KEY]={}
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_datss.cm31.d_flds.cm31b21k,
            ));
            return _cnd;
          };
          let _o_cndMngSht = _dd_datss => {
            let _cnd = bf.q(`
              [cm40b11k]="{}" AND
              [cm40b21k]="{}" AND
              [cm40l11e]="mngSht"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_datss.cm31.d_flds.cm31b21k,
            ));
            return _cnd;
          };
          let _o_cndMngCase = _dd_datss => {
            let _cnd = bf.q(`
              [it10b11k]="{}" AND
              [it10l11e]="mngCase" AND
              [it10l11k]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_datss.mngSht.d_flds._KEY,
            ));
            return _cnd;
          };
          cf.myCB_call_tree({
            dd_cashss: _dd_cashss,
            ctr: 'slc',
            dd_elmDefss: {
              cm31: { // 在籍
                elm: 'cm31',
                o_cnd: _o_cndCm31,
                dd_cldDefss: {
                  cm30: { // 部門
                    elm: 'cm30',
                    o_cnd: _o_cndCm30,
                    dd_cldDefss: {
                      mngSht: { // チェックシート
                        elm: 'cm40',
                        o_cnd: _o_cndMngSht,
                        dd_cldDefss: {
                          mngCase: { // 失敗・クレーム事例
                            elm: 'it10',
                            o_cnd: _o_cndMngCase,
                            op_act: _dd_datss => new Promise( _o_end2 => {
                              let _d = {
                                cm30cz10: _dd_datss.cm30.d_flds.cm30cz10,
                                cm30cx10: _dd_datss.cm30.d_flds.cm30cx10,
                                cm30cw10: _dd_datss.cm30.d_flds.cm30cw10,
                                cm30c310: _dd_datss.cm30.d_flds.cm30c310,
                                mngShtCz10: _dd_datss.mngSht.d_flds.cm40cz10,
                                mngShtCx10: _dd_datss.mngSht.d_flds.cm40cx10,
                                mngShtCw10: _dd_datss.mngSht.d_flds.cm40cw10,
                                mngSht_key: _dd_datss.mngSht.d_flds._KEY,
                                mngShtC310: _dd_datss.mngSht.d_flds.cm40c310,
                                mngCaseCz10: _dd_datss.mngCase.d_flds.it10cz10,
                                mngCaseCx10: _dd_datss.mngCase.d_flds.it10cx10,
                                mngCaseCw10: _dd_datss.mngCase.d_flds.it10cw10,
                                mngCase_key: _dd_datss.mngCase.d_flds._KEY,
                                mngCaseC310: _dd_datss.mngCase.d_flds.it10c310,

                                mngCaseT110: _dd_datss.mngCase.d_flds.it10t110,
                                cm10cw10: _dd_datss.mngCase.d_flds.cm10cw10,
                                cm10c310: _dd_datss.mngCase.d_flds.cm10c310,
                              };
                              _ld_valss.push(_d);
                              _o_end2();
                            }),
                            dd_rfrss: {
                              cm10: {
                                elm: 'cm10',
//                                o_cnd: _d_flds => bf.q('[_KEY]={}'.f(_d_flds.it10cy20))
                                o_cnd: _d_flds => {
//                                  if (_d_flds.it10t110 == '10') return bf.q('[_KEY]={}'.f(_d_flds.it10b21k));
//                                  return bf.q('[_KEY]={}'.f(_d_flds.it10cy20));
                                  return bf.q('[_KEY]={}'.f(_d_flds.it10b21k));
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          })
          .then( () => {
            _o_end1();
          });

        }),
        ld_sortss:[
          {fld:'cm30cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm30cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm30cw10', dtn:'asc', mode:'str'},
          {fld:'cm30_key', dtn:'asc', mode:'nmb'},
          {fld:'mngShtCz10', dtn:'desc', mode:'nmb'},
          {fld:'mngShtCx10', dtn:'asc', mode:'nmb'},
          {fld:'mngShtCw10', dtn:'asc', mode:'str'},
          {fld:'mngSht_key', dtn:'asc', mode:'nmb'},
          {fld:'mngCaseT110', dtn:'desc', mode:'nmb'},
          {fld:'mngCaseCz10', dtn:'desc', mode:'nmb'},
          {fld:'mngCaseCx10', dtn:'asc', mode:'nmb'},
          {fld:'mngCaseCw10', dtn:'asc', mode:'str'},
          {fld:'mngCase_key', dtn:'asc', mode:'nmb'},
        ],
        o_listVal: _d_vals => [
          _d_vals.cm30cw10,
          _d_vals.cm30c310,
          _d_vals.mngShtCw10,
          _d_vals.mngShtC310,
          _d_vals.mngCaseCw10,
          _d_vals.mngCaseC310,
          (_d_vals.mngCaseCz10 == '0') ? '削除する' : '削除しない',

          (_d_vals.mngCaseT110 == '20') ? '共通' : '個人',
          _d_vals.cm10cw10,
          _d_vals.cm10c310,

        ],
      });
    },
  },

  'チェックシート事例CSV取込': {
    pfx: 'チェックシート事例 CSV取込',
    onPrs: () => {
      cf.myRN_iptCsv({
        olp_bfrs: (_d_is, _d_rs, _dd_cashss) => [ // 事前登録されているものが対象

         new Promise( _o_end1 => {

            let _o_cndMngSht = _d_pnts => bf.q(`
              [cm40b11k]="{}" AND
              [cm40l11e]="mngSht" AND 
              [cm40cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['業務ID'],
            ));

            cf.myCB_call_tree({
              ctr: 'slc',
              dd_cashs: _dd_cashss,
              dd_elmDefss: {
                mngSht: {
                  elm: 'cm40',
                  o_cnd: _o_cndMngSht,
                  op_act: _dd_datss => new Promise( _o_end2 => {
                    _d_rs.d_rfrs.mngSht = _dd_datss.mngSht;
                    _o_end2();
                  }),
                },
              },
            })
            .then( _res => {
              _o_end1();
            })

          }),
        ],

        olp_chks: (_d_is, _d_rs, _dd_cashss) => [

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '業務ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm40',
            b_chkEtc: true,
            o_cndElm: () => { // IDの抽出権限
              return bf.q(`
                [cm40b11k]="{}" AND 
                [cm40l11e]="mngSht" AND 
                [cm40cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['業務ID'],
              ));
            },
            l_insRoles: null,
            o_insCndCm31: null,
            l_updRoles: null,
            o_updCndCm31: null,
          }),

          cf.myRN_chkIpt({ // 取込者が業務IDで指定された部門に対する部門運営者であることを確認
            dd_cashss: _dd_cashss,
            name: '業務ID',
            type: '部門運営者',
            d_is: _d_is,
            d_rs: _d_rs,
            b_chk: bf.i(global.c?.state.sgc_pageRole, ['mmb2', 'adm3', 'own4']),
            cm30_key: _d_rs.d_rfrs.mngSht.d_flds.cm40b21k || -1,
          }),

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '事例削除区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['削除しない', '削除する'],
          }),

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '事例区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['共通', '個人'],
          }),

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '利用者ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm10',
            b_chkEtc: true,
            o_cndElm: () => { // IDの抽出権限
              let _cnd = bf.q(`
                [cm10b21k]="{}" AND 
                [cm10cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['利用者ID'],
              ));
              return _cnd;
            },
            o_insCndCm31: null,
            o_updCndCm31: null,
          }),


        ],

        od_bldIuds: (_d_is, _d_rs) => {
          return {
            elm: 'it10',
            od_insVals: _d_plts => {
              let _d = {
                it10b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
//                it10b21k: _d_rs.d_rfrs.mngSht.d_flds.cm40b21k,
//                it10b21k: (_d_is['事例区分'] == '共通') ? _d_rs.d_rfrs.mngSht.d_flds.cm40b21k : _d_rs.d_cm10s._KEY,
                it10b21k: _d_rs.d_cm10s._KEY,
                it10t110: (_d_is['事例区分'] == '共通') ? '20' : '10',
                it10l11e: 'mngCase',
                it10l11k: _d_rs.d_rfrs.mngSht.d_flds._KEY,
                it10cw10: _d_is['事例ID'],
                it10c110: '',
                it10c310: _d_is['事例'],
                it10cx10: _d_is['事例表示順'] || '9999',
                it10cz10: (_d_is['事例削除区分'] == '削除する') ? '0' : '10',
              };
//bf.l('2823:{}'.f(_d))
              return _d;
            },
            od_updVals: _d_plts => {
              let _d = {
//                it10b21k: (_d_is['事例区分'] == '共通') ? _d_rs.d_rfrs.mngSht.d_flds.cm40b21k : _d_rs.d_cm10s._KEY,
                it10b21k: _d_rs.d_cm10s._KEY,
                it10t110: (_d_is['事例区分'] == '共通') ? '20' : '10',
                it10c310: bf.f(_d_is['事例']) ? _d_is['事例'] : null,
                it10cx10: bf.f(_d_is['事例表示順']) ? (_d_is['事例表示順'] || '9999') : null,
                it10cz10: bf.f(_d_is['事例削除区分']) ? ((_d_is['事例削除区分'] == '削除する') ? '0' : '10') : null,
              };
//bf.l('2831:{}'.f(_d))
              return _d;
            },
            o_cnd: _d_plts => {
              let _cnd = bf.q(`
                [it10b11k]="{}" AND 
                [it10l11e]="mngCase" AND 
                [it10l11k]="{}" AND 
                [it10cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.mngSht.d_flds._KEY,
                _d_is['事例ID']
              ));
//bf.l('2838:{}'.f(_cnd))
              return _cnd;
            },
            ld_cldss: [
            ],
          };
        },
        op_atr: () => cf.myRN_set_pageMode('show'),
      });
    },
  },

  '業務一覧CSV出力': {
    pfx: '業務一覧 CSV出力',
    onPrs: () => {
      cf.myRN_eptCsv({
        name: '業務一覧',
        hdr: '"部門ID","部門","業務ID","業務","業務表示順","業務削除区分"',

        op_bldVal: (_ld_valss, _dd_cashss) => new Promise( async _o_end1 => {
//bf.l('2941: here');
          let _o_cndCm31 = _dd_datss => {
            let _cnd = bf.q(`
              [cm31b11k]="{}" AND
              [cm31b21k] IN (
                SELECT 
                  [_KEY]::TEXT 
                FROM 
                  [t_cm30] 
                WHERE 
                  [cm30b11k]="{}" AND 
                  IFNULL([cm31cz10],"10")<>"0" 
              ) AND
              [cm31b31k]="{}" AND
              IFNULL([cm31cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              global.c?.state.sgcd_pagePntKeys.cm10_key,
            ));
//bf.l('2961: {}'.f(_cnd))
            return _cnd;
          };

          let _o_cndCm30 = _dd_datss => {
            let _cnd = bf.q(`
              [cm30b11k]="{}" AND
              [_KEY]={} AND
              IFNULL([cm30cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
//              _dd_datss.cm31.d_flds._KEY,
              _dd_datss.cm31.d_flds.cm31b21k,
            ));
            return _cnd;
          };
          let _o_cndPrcSht = _dd_datss => {
            let _cnd = bf.q(`
              [cm40b11k]="{}" AND
              [cm40b21k]="{}" AND
              [cm40l11e]="prcSht" AND
              IFNULL([cm40cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
//              _dd_datss.cm31.d_flds._KEY,
              _dd_datss.cm30.d_flds._KEY,
            ));
//bf.l('2985: {}'.f(_cnd))
            return _cnd;
          };
          let _op_act = _dd_datss => new Promise( _o_end2 => {
            let _d = {
              cm30_key: _dd_datss.cm30.d_flds._KEY,
              cm30c310: _dd_datss.cm30.d_flds.cm30c310,
              cm30cx10: _dd_datss.cm30.d_flds.cm30cx10,
              cm30cz10: _dd_datss.cm30.d_flds.cm30cz10,
              cm30cw10: _dd_datss.cm30.d_flds.cm30cw10,
              cm40_key: _dd_datss.prcSht.d_flds._KEY,
              cm40c310: _dd_datss.prcSht.d_flds.cm40c310,
              cm40cw10: _dd_datss.prcSht.d_flds.cm40cw10,
              cm40cx10: _dd_datss.prcSht.d_flds.cm40cx10,
              cm40cz10: _dd_datss.prcSht.d_flds.cm40cz10,
            };
//bf.l('3000: {}'.f(_d))
            _ld_valss.push(_d);
            _o_end2();
          });

//bf.l('3005: here');
          cf.myCB_call_tree({
            ctr: 'slc',
            dd_cashss: _dd_cashss,
            dd_elmDefss: {
              cm31: {
                elm: 'cm31',
                o_cnd: _o_cndCm31,
                dd_cldDefss: {
                  cm30: {
                    elm: 'cm30',
                    o_cnd: _o_cndCm30,
                    dd_cldDefss: {
                      prcSht: {
                        elm: 'cm40',
                        o_cnd: _o_cndPrcSht,
                        op_act: _op_act,
                        d_clds: {
                        },
                      },
                    },
                  },
                },
              },
            },
          })
          .then(() => {
//bf.l('3032: here');
            _o_end1();
          });
        }),
        ld_sortss:[
          {fld:'cm30cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm30cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm30cw10', dtn:'asc', mode:'str'},
          {fld:'cm30_key', dtn:'asc', mode:'nmb'},
          {fld:'cm40cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm40cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm40cw10', dtn:'asc', mode:'str'},
          {fld:'cm40_key', dtn:'asc', mode:'nmb'},
        ],
/*
        o_listVal: _d_vals => [
          _d_vals.cm30cw10,
          _d_vals.cm30c310,
          _d_vals.cm40cw10,
          _d_vals.cm40c310,
          _d_vals.cm40cx10,
          (_d_vals.cm40cz10 == '0') ? '削除する' : '削除しない',
        ],
*/
        o_listVal: _d_vals => {
          let _d = [
            _d_vals.cm30cw10,
            _d_vals.cm30c310,
            _d_vals.cm40cw10,
            _d_vals.cm40c310,
            _d_vals.cm40cx10,
            (_d_vals.cm40cz10 == '0') ? '削除する' : '削除しない',
          ]
//bf.l('3061: {}'.f(_d))
          return _d;
        },

      });
    },
  },

  '業務確認事項CSV出力': {
    pfx: '業務確認事項 CSV出力',
    onPrs: () => {
      cf.myRN_eptCsv({
        name: '業務確認事項',
        hdr: '"部門ID","部門","業務ID","業務","確認事項ID","確認事項","確認事項削除区分","確認事項区分","利用者ID","確認事項登録者"',

        op_bldVal: (_ld_valss, _dd_cashss) => new Promise( async _o_end1 => {

          let _o_cndCm31 = _dd_datss => {
            let _cnd = bf.q(`
              [cm31b11k]="{}" AND
              [cm31b21k] IN (
                SELECT 
                  [_KEY]::TEXT 
                FROM 
                  [t_cm30] 
                WHERE 
                  [cm30b11k]="{}" AND 
                  IFNULL([cm31cz10],"10")<>"0" 
              ) AND
              [cm31b31k]="{}" AND
              IFNULL([cm31cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              global.c?.state.sgcd_pagePntKeys.cm10_key,
            ));
            return _cnd;
          };
          let _o_cndCm30 = _dd_datss => {
            let _cnd = bf.q(`
              [cm30b11k]="{}" AND
              [_KEY]={} AND
              IFNULL([cm30cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
//              _dd_datss.cm31.d_flds._KEY,
              _dd_datss.cm31.d_flds.cm31b21k,
            ));
            return _cnd;
          };
          let _o_cndPrcSht = _dd_datss => {
            let _cnd = bf.q(`
              [cm40b11k]="{}" AND
              [cm40b21k]="{}" AND
              [cm40l11e]="prcSht" AND
              IFNULL([cm40cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_datss.cm30.d_flds._KEY,
            ));
            return _cnd;
          };
          let _o_cndPrcChk = _dd_datss => {
            let _cnd = bf.q(`
              [it10b11k]="{}" AND
              [it10l11e]="prcChk" AND
              [it10l11k]="{}" AND
              IFNULL([it10cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_datss.prcSht.d_flds._KEY,
            ));
            return _cnd;
          };
          let _op_act = _dd_datss => new Promise( _o_end2 => {
            let _d = {
              cm30_key: _dd_datss.cm30.d_flds._KEY,
              cm30c310: _dd_datss.cm30.d_flds.cm30c310,
              cm30cx10: _dd_datss.cm30.d_flds.cm30cx10,
              cm30cz10: _dd_datss.cm30.d_flds.cm30cz10,
              cm30cw10: _dd_datss.cm30.d_flds.cm30cw10,
              cm40_key: _dd_datss.prcSht.d_flds._KEY,
              cm40c310: _dd_datss.prcSht.d_flds.cm40c310,
              cm40cw10: _dd_datss.prcSht.d_flds.cm40cw10,
              cm40cx10: _dd_datss.prcSht.d_flds.cm40cx10,
              cm40cz10: _dd_datss.prcSht.d_flds.cm40cz10,
              it10_key: _dd_datss.prcChk.d_flds._KEY,
              it10c310: _dd_datss.prcChk.d_flds.it10c310,
              it10t110: _dd_datss.prcChk.d_flds.it10t110,
              it10cw10: _dd_datss.prcChk.d_flds.it10cw10,
              it10cx10: _dd_datss.prcChk.d_flds.it10cx10,
              it10cz10: _dd_datss.prcChk.d_flds.it10cz10,
              cm10cw10: _dd_datss.prcChk.d_flds.cm10cw10,
              cm10c310: _dd_datss.prcChk.d_flds.cm10c310,
            };
            _ld_valss.push(_d);
            _o_end2();
          });
          cf.myCB_call_tree({
            ctr: 'slc',
            dd_cashss: _dd_cashss,
            dd_elmDefss: {
              cm31: {
                elm: 'cm31',
                o_cnd: _o_cndCm31,
                dd_cldDefss: {
                  cm30: {
                    elm: 'cm30',
                    o_cnd: _o_cndCm30,
                    dd_cldDefss: {
                      prcSht: {
                        elm: 'cm40',
                        o_cnd: _o_cndPrcSht,
                        dd_cldDefss: {
                          prcChk: {
                            elm: 'it10',
                            o_cnd: _o_cndPrcChk,
                            op_act: _op_act,
                            dd_rfrss: {
                              cm10: {
                                elm: 'cm10',
//                                o_cnd: _d_flds => bf.q('[_KEY]={}'.f(_d_flds.it10cy20))
                                o_cnd: _d_flds => {
//                                  if (_d_flds.it10t110 == '10') return bf.q('[_KEY]={}'.f(_d_flds.it10b21k));
//                                  return bf.q('[_KEY]={}'.f(_d_flds.it10cy20));
                                  return bf.q('[_KEY]={}'.f(_d_flds.it10b21k));
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          })
          .then(() => {
            _o_end1();
          });
        }),
        ld_sortss:[
          {fld:'cm30cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm30cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm30cw10', dtn:'asc', mode:'str'},
          {fld:'cm30_key', dtn:'asc', mode:'nmb'},
          {fld:'cm40cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm40cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm40cw10', dtn:'asc', mode:'str'},
          {fld:'cm40_key', dtn:'asc', mode:'nmb'},
          {fld:'it10t110', dtn:'desc', mode:'nmb'},
          {fld:'it10cz10', dtn:'desc', mode:'nmb'},
          {fld:'it10cx10', dtn:'asc', mode:'nmb'},
          {fld:'it10cw10', dtn:'asc', mode:'str'},
          {fld:'it10_key', dtn:'asc', mode:'nmb'},
        ],
        o_listVal: _d_vals => [
          _d_vals.cm30cw10,
          _d_vals.cm30c310,
          _d_vals.cm40cw10,
          _d_vals.cm40c310,
          _d_vals.it10cw10,
          _d_vals.it10c310,
          (_d_vals.it10cz10 == '0') ? '削除する' : '削除しない',
          (_d_vals.it10t110 == '20') ? '共通' : '個人',
          _d_vals.cm10cw10,
          _d_vals.cm10c310,
        ],
      });
    },
  },

  '業務失敗・クレーム事例CSV出力': {
    pfx: '業務失敗・クレーム事例 CSV出力',
    onPrs: () => {
      cf.myRN_eptCsv({
        name: '業務失敗・クレーム事例',
        hdr: '"部門ID","部門","業務ID","業務","事例ID","事例","事例削除区分","事例区分","利用者ID","事例登録者"',

        op_bldVal: (_ld_valss, _dd_cashss) => new Promise( async _o_end1 => {

          let _o_cndCm31 = _dd_datss => {
            let _cnd = bf.q(`
              [cm31b11k]="{}" AND
              [cm31b21k] IN (
                SELECT 
                  [_KEY]::TEXT 
                FROM 
                  [t_cm30] 
                WHERE 
                  [cm30b11k]="{}" AND 
                  IFNULL([cm31cz10],"10")<>"0" 
              ) AND
              [cm31b31k]="{}" AND
              IFNULL([cm31cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              global.c?.state.sgcd_pagePntKeys.cm10_key,
            ));
            return _cnd;
          };
          let _o_cndCm30 = _dd_datss => {
            let _cnd = bf.q(`
              [cm30b11k]="{}" AND
              [_KEY]={} AND
              IFNULL([cm30cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
//              _dd_datss.cm31.d_flds._KEY,
              _dd_datss.cm31.d_flds.cm31b21k,
            ));
            return _cnd;
          };
          let _o_cndPrcSht = _dd_datss => {
            let _cnd = bf.q(`
              [cm40b11k]="{}" AND
              [cm40b21k]="{}" AND
              [cm40l11e]="prcSht" AND
              IFNULL([cm40cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_datss.cm30.d_flds._KEY,
            ));
            return _cnd;
          };
          let _o_cndPrcChk = _dd_datss => {
            let _cnd = bf.q(`
              [it10b11k]="{}" AND
              [it10l11e]="prcCase" AND
              [it10l11k]="{}" AND
              IFNULL([it10cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_datss.prcSht.d_flds._KEY,
            ));
            return _cnd;
          };
          let _op_act = _dd_datss => new Promise( _o_end2 => {
            let _d = {
              cm30_key: _dd_datss.cm30.d_flds._KEY,
              cm30c310: _dd_datss.cm30.d_flds.cm30c310,
              cm30cx10: _dd_datss.cm30.d_flds.cm30cx10,
              cm30cz10: _dd_datss.cm30.d_flds.cm30cz10,
              cm30cw10: _dd_datss.cm30.d_flds.cm30cw10,
              cm40_key: _dd_datss.prcSht.d_flds._KEY,
              cm40c310: _dd_datss.prcSht.d_flds.cm40c310,
              cm40cw10: _dd_datss.prcSht.d_flds.cm40cw10,
              cm40cx10: _dd_datss.prcSht.d_flds.cm40cx10,
              cm40cz10: _dd_datss.prcSht.d_flds.cm40cz10,
              it10_key: _dd_datss.prcChk.d_flds._KEY,
              it10c310: _dd_datss.prcChk.d_flds.it10c310,
              it10t110: _dd_datss.prcChk.d_flds.it10t110,
              it10cw10: _dd_datss.prcChk.d_flds.it10cw10,
              it10cx10: _dd_datss.prcChk.d_flds.it10cx10,
              it10cz10: _dd_datss.prcChk.d_flds.it10cz10,
              cm10cw10: _dd_datss.prcChk.d_flds.cm10cw10,
              cm10c310: _dd_datss.prcChk.d_flds.cm10c310,
            };
            _ld_valss.push(_d);
            _o_end2();
          });
          cf.myCB_call_tree({
            ctr: 'slc',
            dd_cashss: _dd_cashss,
            dd_elmDefss: {
              cm31: {
                elm: 'cm31',
                o_cnd: _o_cndCm31,
                dd_cldDefss: {
                  cm30: {
                    elm: 'cm30',
                    o_cnd: _o_cndCm30,
                    dd_cldDefss: {
                      prcSht: {
                        elm: 'cm40',
                        o_cnd: _o_cndPrcSht,
                        dd_cldDefss: {
                          prcChk: {
                            elm: 'it10',
                            o_cnd: _o_cndPrcChk,
                            op_act: _op_act,
                            dd_rfrss: {
                              cm10: {
                                elm: 'cm10',
//                                o_cnd: _d_flds => bf.q('[_KEY]={}'.f(_d_flds.it10cy20))
                                o_cnd: _d_flds => {
//                                  if (_d_flds.it10t110 == '10') return bf.q('[_KEY]={}'.f(_d_flds.it10b21k));
//                                  return bf.q('[_KEY]={}'.f(_d_flds.it10cy20));
                                  return bf.q('[_KEY]={}'.f(_d_flds.it10b21k));
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          })
          .then(() => {
            _o_end1();
          });
        }),
        ld_sortss:[
          {fld:'cm30cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm30cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm30cw10', dtn:'asc', mode:'str'},
          {fld:'cm30_key', dtn:'asc', mode:'nmb'},
          {fld:'cm40cz10', dtn:'desc', mode:'nmb'},
          {fld:'cm40cx10', dtn:'asc', mode:'nmb'},
          {fld:'cm40cw10', dtn:'asc', mode:'str'},
          {fld:'cm40_key', dtn:'asc', mode:'nmb'},
          {fld:'it10t110', dtn:'desc', mode:'nmb'},
          {fld:'it10cz10', dtn:'desc', mode:'nmb'},
          {fld:'it10cx10', dtn:'asc', mode:'nmb'},
          {fld:'it10cw10', dtn:'asc', mode:'str'},
          {fld:'it10_key', dtn:'asc', mode:'nmb'},
        ],
        o_listVal: _d_vals => [
          _d_vals.cm30cw10,
          _d_vals.cm30c310,
          _d_vals.cm40cw10,
          _d_vals.cm40c310,
          _d_vals.it10cw10,
          _d_vals.it10c310,
          (_d_vals.it10cz10 == '0') ? '削除する' : '削除しない',
          (_d_vals.it10t110 == '20') ? '共通' : '個人',
          _d_vals.cm10cw10,
          _d_vals.cm10c310,
        ],
      });
    },
  },

  '業務一覧CSV取込': {
    pfx: '業務一覧 CSV取込',
    onPrs: () => {
      cf.myRN_iptCsv({

        olp_bfrs: (_d_is, _d_rs, _dd_cashss) => [ // 事前登録されているものが対象

         new Promise( _o_end1 => {

            let _o_cndCm30 = _d_plts => bf.q(`
              [cm30b11k]="{}" AND
              [cm30cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['部門ID'],
            ));

            let _o_cndPrcSht = _d_plts => bf.q(`
              [cm40b11k]="{}" AND
              [cm40l11e]="prcSht" AND
              [cm40cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['業務ID'],
            ));

            cf.myCB_call_tree({
              ctr: 'slc',
              dd_cashs: _dd_cashss,
              dd_elmDefss: {
                cm30: {
                  elm: 'cm30',
                  o_cnd: _o_cndCm30,
                  op_act: _dd_datss => new Promise( _o_end1 => {
                    _d_rs.d_rfrs.cm30 = _dd_datss.cm30;
                    _o_end1();
                  }),
                },
                prcSht: {
                  ctr: 'slc',
                  elm: 'cm40',
                  o_cnd: _o_cndPrcSht,
                  op_act: (_dd_datss) => new Promise( _o_end1 => {
                    _d_rs.d_rfrs.prcSht = _dd_datss.prcSht;
                    _o_end1();
                  }),
                },
              },
            })
            .then( _res => {
              _o_end1();
            })
          }),
        ],

        olp_chks: (_d_is, _d_rs, _dd_cashss) => [

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '業務ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm40',
            o_cndElm: () => { // IDの抽出権限
//bf.l('3883:{}'.f(_d_is))
              return bf.q(`
                [cm40b11k]="{}" AND 
                [cm40l11e]="prcSht" AND 
                [cm40cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['業務ID']
              ));
            },
            b_chkEtc: false,
            l_insRoles: null,
            o_insCndCm31: () => {
              let _cnd = bf.q(`
                [cm31b11k]="{}" AND
                [cm31b21k]="{}" AND
                [cm31b31k]="{}" AND
                IFNULL([cm31b11k],"10")<>"0"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.cm30.d_flds._KEY,
                global.c?.state.sgcd_pagePntKeys.cm10_key,
              ));
              return _cnd;
            },
            l_updRoles: null,
            o_updCndCm31: () => {
              let _cnd = bf.q(`
                [cm31b11k]="{}" AND
                [cm31b21k]="{}" AND
                [cm31b31k]="{}" AND
                IFNULL([cm31b11k],"10")<>"0"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.prcSht.d_flds.cm40b21k,
                global.c?.state.sgcd_pagePntKeys.cm10_key,
              ));
              return _cnd;
            },
          }),

          cf.myRN_chkIpt({
            name: '業務表示順',
            type: '数値',
            d_is: _d_is,
            d_rs: _d_rs,
          }),

          cf.myRN_chkIpt({
            name: '業務削除区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['削除しない', '削除する'],
          }),

        ],
        od_bldIuds: (_d_is, _d_rs) => {
          return {
            elm: 'cm40',
            od_insVals: _d_plts => {
              let _d = {
                cm40b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
                cm40b21k: _d_rs.d_rfrs.cm30.d_flds._KEY,
                cm40l11e: 'prcSht',
                cm40l11k: '1',
                cm40c110: '',
                cm40c310: _d_is['業務'],
                cm40cx10: _d_is['業務表示順'] || '9999',
                cm40cz10: (_d_is['業務削除区分'] == '削除する') ? '0' : '10',
                cm40cw10: _d_is['業務ID'],
              };
              return _d;
            },
            od_updVals: _d_plts => {
              let _d = {
                cm40c310: bf.f(_d_is['業務']) ? _d_is['業務'] : null,
                cm40cx10: bf.f(_d_is['業務表示順']) ? (_d_is['業務表示順'] || '9999') : null,
                cm40cz10: bf.f(_d_is['業務削除区分']) ? ((_d_is['業務削除区分'] == '削除する') ? '0' : '10') : null,
              };
              return _d;
            },
            o_cnd: _d_plts => {
              let _cnd = bf.q(`
                [cm40b11k]="{}" AND 
                [cm40l11e]="prcSht" AND 
                [cm40l11k]="1" AND 
                [cm40cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['業務ID']
              ));
              return _cnd;
            },
            ld_cldss: [
            ],
          };
        },
        op_atr: () => cf.myRN_set_pageMode('show'),
      });
    },
  },

  '業務確認事項CSV取込': {
    pfx: '業務確認事項 CSV取込',
    onPrs: () => {
      cf.myRN_iptCsv({

        olp_bfrs: (_d_is, _d_rs, _dd_cashss) => [ // 事前登録されているものが対象

         new Promise( _o_end1 => {

            let _o_cndPrcSht = _d_pnts => bf.q(`
              [cm40b11k]="{}" AND
              [cm40l11e]="prcSht" AND 
              [cm40cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['業務ID'],
            ));

            cf.myCB_call_tree({
              ctr: 'slc',
              dd_cashs: _dd_cashss,
              dd_elmDefss: {
                prcSht: {
                  elm: 'cm40',
                  o_cnd: _o_cndPrcSht,
                  op_act: _dd_datss => new Promise( _o_end1 => {
//bf.l('3591: {}'.f(_dd_datss))
                    _d_rs.d_rfrs.prcSht = _dd_datss.prcSht;
                    _o_end1();
                  }),
                  d_clds: {
                  }
                },
              },
            })
            .then( _res => {
//bf.l('3600: {}'.f(_d_rs.d_rfrs))
              _o_end1();
            })
          }),
        ],

        olp_chks: (_d_is, _d_rs, _dd_cashss) => [

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '業務ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm40',
            o_cndElm: () => { // IDの抽出権限
//bf.l('3883:{}'.f(_d_is))
              return bf.q(`
                [cm40b11k]="{}" AND 
                [cm40l11e]="prcSht" AND 
                [cm40cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['業務ID']
              ));
            },
            b_chkEtc: true,
            l_insRoles: null,
            o_insCndCm31: null,
            l_updRoles: null,
            o_updCndCm31: null,
          }),

          cf.myRN_chkIpt({ // 取込者が業務IDで指定された部門に対する部門運営者であることを確認
            dd_cashss: _dd_cashss,
            name: '業務ID',
            type: '部門運営者',
            d_is: _d_is,
            d_rs: _d_rs,
//            b_chk: bf.i(global.c?.state.sgc_pageRole, ['mmb2', 'adm3', 'own4']),
            b_chk: bf.i(global.c?.state.sgc_pageRole, ['mmb1', 'adm2', 'own3']),
            cm30_key: _d_rs.d_rfrs.prcSht?.d_flds.cm40b21k ?? -1,
          }),

/*
          cf.myRN_chkIpt({
            name: '確認事項分類',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['部門'],
          }),
*/
          cf.myRN_chkIpt({
            name: '確認事項区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['共通','個人'],
          }),

          cf.myRN_chkIpt({
            name: '確認事項削除区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['削除しない', '削除する'],
          }),

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '利用者ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm10',
            b_chkEtc: true,
            o_cndElm: () => { // IDの抽出権限
              let _cnd = bf.q(`
                [cm10b21k]="{}" AND 
                [cm10cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['利用者ID'],
              ));
              return _cnd;
            },
            o_insCndCm31: null,
            o_updCndCm31: null,
          }),

        ],
        od_bldIuds: (_d_is, _d_rs) => {
          return {
            elm: 'it10',
            od_insVals: _d_plts => {
              let _d = {
                it10b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
//                it10b21k: global.c?.state.sgcd_pagePntKeys.cm20_key,
//                it10b21k: (_d_is['確認事項区分'] == '共通') ? global.c?.state.sgcd_pagePntKeys.cm20_key : _d_rs.d_cm10s._KEY,
                it10b21k: _d_rs.d_cm10s._KEY,
                it10b31k: _d_rs.d_rfrs.prcSht.d_flds.cm40b21k,
                it10l11e: 'prcChk',
                it10l11k: _d_rs.d_rfrs.prcSht.d_flds._KEY,
                it10c110: '',
                it10c310: _d_is['確認事項'],
//                it10t110: '20',
                it10t110: (_d_is['確認事項区分'] == '共通') ? '20' : '10',
                it10cx10: _d_is['確認事項表示順'] || '9999',
                it10cz10: (_d_is['確認事項削除区分'] == '削除する') ? '0' : '10',
                it10cw10: _d_is['確認事項ID'],
//                it10cy20: _d_is['利用者ID'],
              };
//bf.l('3944: {}'.f(_d));
              return _d;
            },
            od_updVals: _d_plts => { // ID の混在を避けるため、確認事項区分の途中変更は不可
              let _d = {
//                it10b21k: (_d_is['確認事項区分'] == '共通') ? global.c?.state.sgcd_pagePntKeys.cm20_key : _d_rs.d_cm10s._KEY,
                it10b21k: _d_rs.d_cm10s._KEY,
                it10c310: bf.f(_d_is['確認事項']) ? _d_is['確認事項'] : null,
                it10t110: (_d_is['確認事項区分'] == '共通') ? '20' : '10',
                it10cx10: bf.f(_d_is['確認事項表示順']) ? (_d_is['確認事項表示順'] || '9999') : null,
                it10cz10: bf.f(_d_is['確認事項削除区分']) ? ((_d_is['確認事項削除区分'] == '削除する') ? '0' : '10') : null,
//                it10cy20: _d_is['利用者ID'],
              };
//bf.l('3952: {}'.f(_d));
              return _d;
            },
            o_cnd: _d_plts => {
              let _cnd = bf.q(`
                [it10b11k]="{}" AND 
                [it10l11e]="prcChk" AND 
                [it10l11k]="{}" AND 
                [it10cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.prcSht.d_flds._KEY,
                _d_is['確認事項ID']
              ));
//                (_d_is['確認事項区分'] == '共通') ? '20' : '10',
//                [it10t110]="{}" AND
//bf.l('3966: {}'.f(_cnd));
              return _cnd;
            },
            ld_cldss: [
            ],
          };
        },
        op_atr: () => cf.myRN_set_pageMode('show'),
      });
    },
  },

  '業務失敗・クレーム事例CSV取込': {
    pfx: '業務失敗・クレーム事例 CSV取込',
    onPrs: () => {
      cf.myRN_iptCsv({

        olp_bfrs: (_d_is, _d_rs, _dd_cashss) => [ // 事前登録されているものが対象

         new Promise( _o_end1 => {

            let _o_cndPrcSht = _d_pnts => bf.q(`
              [cm40b11k]="{}" AND
              [cm40l11e]="prcSht" AND 
              [cm40cw10]="{}"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _d_is['業務ID'],
            ));

            cf.myCB_call_tree({
              ctr: 'slc',
              dd_cashs: _dd_cashss,
              dd_elmDefss: {
                prcSht: {
                  elm: 'cm40',
                  o_cnd: _o_cndPrcSht,
                  op_act: _dd_datss => new Promise( _o_end1 => {
                    _d_rs.d_rfrs.prcSht = _dd_datss.prcSht;
                    _o_end1();
                  }),
                  d_clds: {
                  }
                },
              },
            })
            .then( _res => {
              _o_end1();
            })
          }),
        ],

        olp_chks: (_d_is, _d_rs, _dd_cashss) => [

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '業務ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm40',
            o_cndElm: () => { // IDの抽出権限
//bf.l('3883:{}'.f(_d_is))
              return bf.q(`
                [cm40b11k]="{}" AND 
                [cm40l11e]="prcSht" AND 
                [cm40cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['業務ID']
              ));
            },
            b_chkEtc: true,
            l_insRoles: null,
            o_insCndCm31: null,
            l_updRoles: null,
            o_updCndCm31: null,
          }),

          cf.myRN_chkIpt({ // 取込者が業務IDで指定された部門に対する部門運営者であることを確認
            dd_cashss: _dd_cashss,
            name: '業務ID',
            type: '部門運営者',
            d_is: _d_is,
            d_rs: _d_rs,
            b_chk: bf.i(global.c?.state.sgc_pageRole, ['mmb1', 'adm2', 'own3']),
            cm30_key: _d_rs.d_rfrs.prcSht.d_flds.cm40b21k || -1,
          }),


          cf.myRN_chkIpt({
            name: '事例削除区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['削除しない', '削除する'],
          }),

          cf.myRN_chkIpt({
            name: '事例区分',
            type: '区分値',
            d_is: _d_is,
            d_rs: _d_rs,
            l_is: ['共通','個人'],
          }),

          cf.myRN_chkIpt({
            dd_cashss: _dd_cashss,
            name: '利用者ID',
            type: 'ID',
            d_is: _d_is,
            d_rs: _d_rs,
            elm: 'cm10',
            b_chkEtc: true,
            o_cndElm: () => { // IDの抽出権限
              let _cnd = bf.q(`
                [cm10b21k]="{}" AND 
                [cm10cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_is['利用者ID'],
              ));
              return _cnd;
            },
            o_insCndCm31: null,
            o_updCndCm31: null,
          }),

        ],
        od_bldIuds: (_d_is, _d_rs) => {
          return {
            elm: 'it10',
            od_insVals: _d_plts => {
              let _d = {
                it10b11k: (global.c?.state.sgc_pageRole == 'own1') ? '0' : global.c?.state.sgcd_pagePntKeys.cm20_key,
//                it10b21k: global.c?.state.sgcd_pagePntKeys.cm20_key,
//                it10b21k: (_d_is['事例区分'] == '共通') ? global.c?.state.sgcd_pagePntKeys.cm20_key : _d_rs.d_cm10s._KEY,
                it10b21k: _d_rs.d_cm10s._KEY,
                it10b31k: _d_rs.d_rfrs.prcSht.d_flds.cm40b21k,
                it10l11e: 'prcCase',
                it10l11k: _d_rs.d_rfrs.prcSht.d_flds._KEY,
                it10c110: '',
                it10c310: _d_is['事例'],
//                it10t110: '20',
                it10t110: (_d_is['事例区分'] == '共通') ? '20' : '10',
//                it10cx10: _d_is['事例表示順'] || '9999',
                it10cz10: (_d_is['事例削除区分'] == '削除する') ? '0' : '10',
                it10cw10: _d_is['事例ID'],
//                it10cw10: _d_is['事例ID'],
//                it10cy20: _d_rs.d_cm10s._KEY,
              };
//bf.l('3894: {}'.f(_d));
              return _d;
            },
            od_updVals: _d_plts => {
//bf.l('3898: {}'.f(_d_is))
//bf.l('3899: {}'.f(_d_rs))
//bf.l('3900: {}'.f(_d_plts))
              let _d = {
//                it10b21k: (_d_is['事例区分'] == '共通') ? global.c?.state.sgcd_pagePntKeys.cm20_key : _d_rs.d_cm10s._KEY,
                it10b21k: _d_rs.d_cm10s._KEY,
                it10c310: bf.f(_d_is['事例']) ? _d_is['事例'] : null,
                it10t110: (_d_is['事例区分'] == '共通') ? '20' : '10',
//                it10cx10: bf.f(_d_is['事例表示順']) ? (_d_is['事例表示順'] || '9999') : null,
                it10cz10: bf.f(_d_is['事例削除区分']) ? ((_d_is['事例削除区分'] == '削除する') ? '0' : '10') : null,
//                it10cy20: _d_rs.d_cm10s._KEY,
              };
//bf.l('3909: {}'.f(_d));
              return _d;
            },
            o_cnd: _d_plts => {
              let _cnd = bf.q(`
                [it10b11k]="{}" AND 
                [it10l11e]="prcCase" AND 
                [it10l11k]="{}" AND 
                [it10cw10]="{}"
              `.f(
                global.c?.state.sgcd_pagePntKeys.cm20_key,
                _d_rs.d_rfrs.prcSht.d_flds._KEY,
                _d_is['事例ID']
              ));
//                [it10t110]="20" AND
//bf.l('3966: {}'.f(_cnd));
              return _cnd;
            },
            ld_cldss: [
            ],
          };
        },
        op_atr: () => cf.myRN_set_pageMode('show'),
      });
    },
  },

};

  static ild_onChgss = () => [ // onChgss for individual app
  ];
}
